
    <template>
      <section class="content element-doc">
        <h2>Table 表格</h2>
<p>用于展示多条结构类似的数据，可对数据进行排序、筛选、对比或其他自定义操作。</p>
<h3>表格自适应内容区高度</h3>
<p>用于表格自适应内容区高度，撑满整页屏幕</p>
<div class="warning">
<p>注意：当设置为<code>adaptive</code>自适应高度时，<code>options.height</code>设置将无效，因为在<code>adaptive</code>模式下表格的<code>options.height</code>默认为<code>100%</code></p>
</div>
<demo-block>
        <div><p>在<code>apex-table</code>组件中传入<code>adaptive</code>属性，即可开启表格自适应内容区高度，<code>adaptive</code>属性是一个对象，自适应内容区高度相关配置（<code>offsetBottom</code>：表格距离页面底部的偏移量，默认值为 <code>60</code>、<code>timeout</code>：页面 <code>resize</code> 时的防抖时间，默认值为 <code>60</code> ms。暴露出 <code>setAdaptive</code> 方法，可以设置表格自适应高度（用于表格外的元素高度改变或者元素隐藏时主动对表格进行自适应高度调整）</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;div style=&quot;display: flex&quot;&gt;
  &lt;el-button @click=&quot;$refs.refAdaptiveTable.setAdaptive()&quot;&gt;手动调用setAdaptive&lt;/el-button&gt;
  &lt;el-alert title=&quot;试试把滚动条往下滚动一点，让表格移位，然后再点击按钮（手动调用setAdaptive）&quot; type=&quot;info&quot; show-icon :closable=&quot;false&quot; style=&quot;margin-left: 20px&quot; /&gt;
&lt;/div&gt;
&lt;apex-table ref=&quot;refAdaptiveTable&quot; :columns=&quot;columns&quot; :data=&quot;data&quot; :adaptive=&quot;{ offsetBottom: 70 }&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: true
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>基础用法</h3>
<p>基础的表格展示用法。</p>
<demo-block>
        <div><p>在<code>apex-table</code>组件中传入<code>columns</code>和<code>data</code>对象数组，即可创建一个最基础的表格，<code>columns</code>中的<code>key</code>需要与<code>data</code>中对象的<code>key</code>严格对照，可以在<code>columns</code>对象中传入<code>width</code>属性来控制列宽。</p>
</div>
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; @row-dblclick=&quot;testClick&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      loaidng: true,
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  },
  methods: {
    testClick() {
      console.log(12111)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>加载状态</h3>
<p>table的loading效果。</p>
<demo-block>
        <div><p>在<code>apex-table</code>组件中传入<code>loading</code>，即可控制表格加载状态，<code>loading</code>的可选值为<code>true</code>和<code>false</code>。</p>
</div>
        <template slot="source"><element-demo2 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;el-button @click=&quot;loading = !loading&quot;&gt;点我切换加载状态&lt;/el-button&gt;
&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :loading=&quot;loading&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: true
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>不带边框表格</h3>
<demo-block>
        <div><p>默认情况下，<code>apex-table</code>是具有竖直方向的边框的，如果不需要，可以在<code>options</code>对象中传入一个<code>border</code>属性，它接受一个<code>Boolean</code>，设置为<code>false</code>即可不带竖直方向的边框。</p>
</div>
        <template slot="source"><element-demo3 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :options=&quot;options&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        border: false
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>表头列宽拖动持久化保存</h3>
<p>拖动列宽后保存状态</p>
<demo-block>
        <div><p>设置<code>toolbar.resizable</code>属性来使列宽拖动设置保存到本地<code>localStorage</code>，该功能默认为<code>true</code>开启，如需关闭设置为<code>false</code>即可。注意：必须和<code>toolbar.columnsSetup</code>一起使用。示例如下：可以拖动列宽后然后F5刷新浏览器试试。</p>
</div>
        <template slot="source"><element-demo4 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :toolbar=&quot;{ storage: 'toolbar_resizable_storage', columnsSetup: true, resizable: true }&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>顶部工具栏</h3>
<p>顶部工具栏具有配置展示列、固定列、排序列顺序的功能，包括刷新table和顶部操作按钮栏，可通过配置此项实现。</p>
<demo-block>
        <div><p>设置<code>toolbar</code>属性来显示顶部工具栏，默认不显示工具栏，给<code>toolbar</code>设置<code>storage</code>属性来使列设置保存到本地<code>localStorage</code>，设置<code>toolbar.storageNeedPrefix</code>为<code>false</code>可去掉localstorage中默认保存的当前路由前缀，该参数默认为<code>true</code>，设置<code>toolbar.refresh</code>为<code>false</code>可隐藏工具栏的刷新按钮，默认为<code>true</code>显示刷新按钮，<code>refresh</code>回调函数里可自定义处理代码。设置<code>headerOperations</code>属性可定义操作按钮。示例如下：</p>
</div>
        <template slot="source"><element-demo5 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :loading=&quot;loading&quot;
  :toolbar=&quot;{ storage: 'toolbar-storage', storageNeedPrefix: false }&quot;
  :header-operations=&quot;headerOperations&quot;
  :options=&quot;options&quot;
  @refresh=&quot;init&quot;
  @add=&quot;add&quot;
  @edit=&quot;edit&quot;
&gt;
  &lt;template v-slot:slotButton&gt;
    &lt;el-dropdown style=&quot;margin-right: 10px&quot;&gt;
      &lt;el-button type=&quot;primary&quot;&gt;
        更多菜单&lt;i class=&quot;el-icon-arrow-down el-icon--right&quot;&gt;&lt;/i&gt;
      &lt;/el-button&gt;
      &lt;el-dropdown-menu slot=&quot;dropdown&quot;&gt;
        &lt;el-dropdown-item&gt;黄金糕&lt;/el-dropdown-item&gt;
        &lt;el-dropdown-item&gt;狮子头&lt;/el-dropdown-item&gt;
        &lt;el-dropdown-item&gt;螺蛳粉&lt;/el-dropdown-item&gt;
        &lt;el-dropdown-item&gt;双皮奶&lt;/el-dropdown-item&gt;
        &lt;el-dropdown-item&gt;蚵仔煎&lt;/el-dropdown-item&gt;
      &lt;/el-dropdown-menu&gt;
    &lt;/el-dropdown&gt;
  &lt;/template&gt;
  &lt;template v-slot:headerOperationSlot&gt;
    &lt;el-checkbox v-model=&quot;checked&quot;&gt;插槽进来的按钮&lt;/el-checkbox&gt;
  &lt;/template&gt;
&lt;/apex-table&gt;

&lt;script&gt;
export default {
  data() {
    return {
      checked: false,
      renderHeaderValue: '',
      columns: [
        { title: '日期', key: 'date', minWidth: 200, disabled: true },
        { title: '测试列1', key: 'test1', minWidth: 200 },
        { title: '测试列2', key: 'test2', minWidth: 200 },
        { title: '测试列3', key: 'test3', minWidth: 200 },
        { title: '默认隐藏列', key: 'hidden', minWidth: 200, show: false },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      headerOperations: [
        { text: '新增', type: 'primary', icon: 'el-icon-plus', emit: 'add' },
        { slotName: 'slotButton' },
        { text: '修改', type: 'danger', icon: 'el-icon-edit', emit: 'edit' }
      ],
      options: {
        border: true
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() =&gt; {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    add() {
      this.$message.success('点击了新增按钮')
    },
    edit() {
      this.$message.success('点击了修改按钮')
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>顶部工具栏(导出excel)</h3>
<p>配合后台接口实现导出excel功能</p>
<demo-block>
        <div><p>设置<code>toolbar</code>属性来显示顶部工具栏，默认不显示工具栏，给<code>toolbar</code>设置<code>storage</code>属性来使列设置保存到本地<code>localStorage</code>，设置<code>toolbar.refresh</code>为<code>false</code>可隐藏工具栏的刷新按钮，默认为<code>true</code>显示刷新按钮，<code>refresh</code>回调函数里可自定义处理代码。设置<code>headerOperations</code>属性可定义操作按钮。示例如下：</p>
</div>
        <template slot="source"><element-demo6 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :loading=&quot;loading&quot;
  :toolbar=&quot;{ storage: 'exportExcel-storage', exportExcel: true }&quot;
  @refresh=&quot;init&quot;
  @export-excel=&quot;exportExcel&quot;
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', minWidth: 200 },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() =&gt; {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    exportExcel(list) {
      console.log(list)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>顶部工具栏 禁止排序</h3>
<p>禁止列排序，只可显示隐藏列</p>
<demo-block>
        <div><p>设置<code>toolbar</code>的<code>disabledFixed</code>和<code>disabledSort</code>为<code>true</code>可禁止列排序。示例如下：</p>
</div>
        <template slot="source"><element-demo7 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :loading=&quot;loading&quot;
  :toolbar=&quot;{ storage: 'toolbar-storage-sort', disabledFixed: true, disabledSort: true }&quot;
  :header-operations=&quot;headerOperations&quot;
  :options=&quot;options&quot;
  @refresh=&quot;init&quot;
  @add=&quot;add&quot;
  @edit=&quot;edit&quot;
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      renderHeaderValue: '',
      columns: [
        { title: '日期', key: 'date', width: 200, disabled: true },
        { title: '自定义表头', key: 'renderHeader', width: 200,
          renderHeader: (h, { column, $index }) =&gt; {
            const that = this
            return h('div', { class: { 'rendered-header': true }}, [
              h('div', column.label),
              h('el-input', {
                props: {
                  value: that.renderHeaderValue,
                  clearable: true
                },
                attrs: { placeholder: 'filter column' },
                 on: {
                  input(val) {
                    that.renderHeaderValue = val
                  }
                }
              })
            ])
          }
        },
        { title: '测试列1', key: 'test1', width: 200 },
        { title: '测试列2', key: 'test2', width: 200 },
        { title: '测试列3', key: 'test3', width: 200 },
        { title: '默认隐藏列', key: 'hidden', width: 200, show: false },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address', width: 400 }
      ],
      data: [
        { date: '2020-04-12', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      headerOperations: [
        { text: '新增', type: 'primary', icon: 'el-icon-plus', emit: 'add' },
        { text: '修改', type: 'danger', icon: 'el-icon-edit', emit: 'edit' }
      ],
      options: {
        border: true
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() =&gt; {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    add() {
      this.$message.success('点击了新增按钮')
    },
    edit() {
      this.$message.success('点击了修改按钮')
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>顶部工具栏 mark行（本地持久化 标记行颜色-待处理）</h3>
<p>mark行功能，标记行颜色，常用于待处理数据先标记明日再处理等需求。</p>
<demo-block>
        <div><p>给<code>toolbar</code>设置<code>storage</code>属性来使行颜色设置保存到本地<code>localStorage</code>，给<code>toolbar</code>设置<code>mark</code>属性来开启标记行功能，<code>mark</code>字段必须指定一个行数据的rowKey作为主键（rowKey必须保证唯一性）。示例如下：</p>
</div>
        <template slot="source"><element-demo8 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  ref=&quot;apexTable&quot;
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :loading=&quot;loading&quot;
  :toolbar=&quot;{ storage: 'toolbar-mark', mark: 'id' }&quot;
  :header-operations=&quot;headerOperations&quot;
  :selection-row=&quot;{ isRowClick: true, isBgc: true }&quot;
  @refresh=&quot;init&quot;
  @complete=&quot;complete&quot;
  @reset=&quot;reset&quot;
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      renderHeaderValue: '',
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { id: 1, date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { id: 2, date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { id: 3, date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { id: 4, date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 5, date: '2020-04-14', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 6, date: '2020-04-15', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 7, date: '2020-04-16', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 8, date: '2020-04-17', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 9, date: '2020-04-18', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      headerOperations: [
        { text: '重置第二行mark状态', type: 'primary', emit: 'complete' },
        { text: '清空所有行mark状态', type: 'danger', emit: 'reset' }
      ]
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() =&gt; {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    complete() {
      this.$refs.apexTable.setMarkRow(this.data[1])
    },
    reset() {
      this.$refs.apexTable.clearAllMarkRow()
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>顶部工具栏 组合排序</h3>
<p>组合排序，多条件排序。</p>
<demo-block>
        <div><p>给 <code>columns</code> 传入 <code>combSort</code> 开启组合排序，点击确定按钮后会触发<code>combSortChange</code>回调函数，可在该函数中请求后端接口进行table组合排序。示例如下：</p>
</div>
        <template slot="source"><element-demo9 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :loading=&quot;loading&quot;
  :toolbar=&quot;toolbarOptions&quot;
  ref=&quot;apexTable&quot;
  @refresh=&quot;init&quot;
  @combSortChange=&quot;combSortChange&quot;
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', minWidth: 200, disabled: true, combSort: true },
        { title: '姓名', key: 'name', minWidth: 200,
          combSort: { title: '自定义title', key: 'testKey', orderBy: 'desc' }
        },
        { title: '地址', key: 'address', minWidth: 400, combSort: { orderBy: 'asc' } }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      toolbarOptions: {
        storage: 'comSortTable'
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() =&gt; {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    combSortChange(sortList, changeType) {
      console.log(sortList)
      console.log(changeType)
      this.$message('按需请求接口排序')
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>顶部工具栏 组合排序（自定义组合排序字段）</h3>
<p>组合排序，多条件排序，自定义字段升降序和顺序</p>
<demo-block>
        <div><p>给<code>toolbar</code>传入<code>combSortList</code>属性来开启组合排序的自定义，<code>combSortList</code>是一个数组。抛出方法 <code>setCombSortList(list)</code> 函数，可以调用该函数动态设置排序字段，示例如下：</p>
</div>
        <template slot="source"><element-demo10 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;el-button type=&quot;primary&quot; @click=&quot;setCombSortList&quot;&gt;动态设置组合排序字段&lt;/el-button&gt;
&lt;apex-table
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :loading=&quot;loading&quot;
  :toolbar=&quot;toolbarOptions&quot;
  ref=&quot;apexTable&quot;
  @refresh=&quot;init&quot;
  @combSortChange=&quot;combSortChange&quot;
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', minWidth: 200, disabled: true },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      toolbarOptions: {
        storage: 'comSortTable',
        combSortList: [
          { title: '地址', key: 'address', orderBy: 'desc' },
          { title: '日期', key: 'date', orderBy: 'asc' },
          { title: '姓名', key: 'name', orderBy: '' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() =&gt; {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000)
    },
    combSortChange(sortList, changeType) {
      console.log(sortList)
      console.log(changeType)
      this.$message('按需请求接口排序')
    },
    setCombSortList() {
      this.loading = true
      setTimeout(() =&gt; {
        const list = [
          { title: '动态字段111', key: 'sortField1', orderBy: 'asc' },
          { title: '动态字段222', key: 'sortField2', orderBy: '' },
          { title: '动态字段333', key: 'sortField3', orderBy: 'desc' },
        ]
        this.$refs.apexTable.setCombSortList(list)
        this.$message.success('动态设置组合排序字段成功')
        this.loading = false
      }, 2000)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>顶部工具栏 toolbar 自定义按钮</h3>
<p>右侧toolbar自定义按钮，方便拓展</p>
<demo-block>
        <div><p>可设置<code>toolbar</code>的<code>columnsSetup</code>属性为<code>false</code>来隐藏列设置按钮，默认为<code>true</code>显示。设置<code>toolbar</code>的<code>customBtns</code>属性来自定义按钮，<code>customBtns</code>是一个数组。也可以使用插槽<code>toolbarSlot</code>来自定义组件，<code>toolbarSlotPosition</code>属性可以设置toolbar插槽的位置（可选值left、right和空字符串，默认空字符串），示例如下：</p>
</div>
        <template slot="source"><element-demo11 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :loading=&quot;loading&quot;
  :toolbar=&quot;toolbarOptions&quot;
  :options=&quot;options&quot;
  @refresh=&quot;init&quot;
  @customFn1=&quot;customFn1&quot;
  @customFn2=&quot;customFn2&quot;
&gt;
  &lt;template v-slot:toolbarSlot&gt;
    &lt;el-checkbox v-model=&quot;checked&quot; style=&quot;margin-right: 10px&quot;&gt;插槽的组件&lt;/el-checkbox&gt;
  &lt;/template&gt;
&lt;/apex-table&gt;

&lt;script&gt;
export default {
  data() {
    return {
      checked: false,
      columns: [
        { title: '日期', key: 'date', minWidth: 200 },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      toolbarOptions: {
        columnsSetup: false,
        storage: 'customBtns-table',
        customBtns: [
          { title: '自定义toolbar按钮1', icon: 'el-icon-bottom', emit: 'customFn1' },
          { title: '自定义toolbar按钮2', icon: 'el-icon-share', type: 'primary', emit: 'customFn2' }
        ],
        advancedSearch: true,
        toolbarSlotPosition: 'left'
      },
      options: {
        border: true
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() =&gt; {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    customFn1() {
      this.$message.success('点击了 自定义toolbar按钮1')
      if (this.toolbarOptions.customBtns[0].icon === 'el-icon-bottom') {
        this.toolbarOptions.customBtns[0].icon = 'el-icon-top'
        this.toolbarOptions.customBtns[0].type = 'success'
      } else {
        this.toolbarOptions.customBtns[0].icon = 'el-icon-bottom'
        this.toolbarOptions.customBtns[0].type = ''
      }
    },
    customFn2() {
      this.$message.success('点击了 自定义toolbar按钮2')
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>搜索过滤</h3>
<p>本地搜索过滤列数据</p>
<demo-block>
        <div><p>在<code>columns</code>中设置<code>filterColumn</code>属性，该属性是一个对象，设置<code>filterColumn.name</code>来指定过滤组件（目前只支持<code>el-input</code>、<code>el-select</code>、<code>el-date-picker</code>组件，如需其他组件或有更复杂的本地过滤需求可使用<code>renderHeader</code>属性来自定义表头），也可以使用slot插槽来实现，如下插槽所示。搜索过滤功能除内置默认过滤方法外，可定义<code>customMethod</code>为自定义过滤方法。传入<code>header-bgc</code>属性可开启深色表头，示例如下：</p>
</div>
        <template slot="source"><element-demo12 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  ref=&quot;apexTable&quot;
  header-bgc
  :loading=&quot;tableLoading&quot;
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :header-operations=&quot;headerOperations&quot;
  :toolbar=&quot;toolbarOptions&quot;
  @resetSearchValue=&quot;resetSearchValue&quot;
  @asyncGetData=&quot;asyncGetData&quot;
&gt;
  &lt;template v-slot:countSlot=&quot;{ scope }&quot;&gt;
    &lt;span&gt;{{ scope.title }} - slot自定义标题&lt;/span&gt;
    &lt;div class=&quot;apex-table-header-slot&quot;&gt;
      &lt;el-input v-model=&quot;scope.filterColumnObj[scope.filterColumn.keys[0]]&quot; placeholder=&quot;插槽示例&quot;&gt;&lt;/el-input&gt;
      &lt;span&gt;-&lt;/span&gt;
      &lt;el-input v-model=&quot;scope.filterColumnObj[scope.filterColumn.keys[1]]&quot; placeholder=&quot;插槽示例&quot;&gt;&lt;/el-input&gt;
    &lt;/div&gt;
  &lt;/template&gt;
&lt;/apex-table&gt;

&lt;script&gt;
export default {
  data() {
    return {
      tableLoading: false,
      asyncList: [],
      headerOperations: [
        { text: '重置过滤框值', type: 'primary', emit: 'resetSearchValue' },
        { text: '异步获取姓名下拉', type: 'primary', emit: 'asyncGetData' }
      ],
      toolbarOptions: {
        storage: 'toolbar-reset-table',
        reset: true
      },
      data: [
        { date: '2022-06-12', count: 111, type: '类型1', name: '詹姆斯', name2: 1, address: '武汉市江汉区泛海国际SOHO城 1518 弄' },
        { date: '2022-06-14', count: 222, type: '类型2', name: '安东尼', name2: 0, address: '武汉市江汉区泛海国际SOHO城 1517 弄' },
        { date: '2022-06-11', count: 123, type: '类型3', name: '奥尼尔', name2: true, address: '武汉市江汉区泛海国际SOHO城 1519 弄' },
        { date: '2022-06-13', count: 356, type: '类型4', name: '杜兰特', name2: false, address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      columns: [
        { title: '日期', key: 'date', align: 'center', width: 250,
          filterColumn: {
            name: 'el-date-picker',
            type: 'daterange',
            // value: ['2022-06-03', '2022-06-15'], // 默认值
            value: () =&gt; {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            },
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '开始日期',
            'end-placeholder': '结束日期',
            keys: ['datetime'] // key别名，传给后台用的 不填默认为列的key
          }
        },
        { title: '起止日期框分开', key: 'date2', align: 'center', width: 300,
          filterColumn: {
            name: 'begin-end-date',
            keys: ['beginDate', 'endDate'],
            value: ['2022-06-03', '2022-06-15'], // 默认值
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            isRemote: true
          }
        },
        { title: 'apex-select下拉组件', key: 'type', align: 'center', width: 160,
          filterColumn: {
            name: 'apex-select',
            remote: true,
            localFilter: { max: 10 },
            options: [
              { label: '标题1', value: 1 },
              { label: '标题2', value: 2 },
              { label: '标题3', value: 3 },
              { label: '标题4', value: 4 },
              { label: '标题5', value: 5 },
              { label: '标题6', value: 6 },
              { label: '标题7', value: 7 },
              { label: '标题8', value: 8 },
              { label: '标题9', value: 9 },
              { label: '标题10', value: 10 },
              { label: '标题11', value: 11 },
              { label: '标题12', value: 12 },
              { label: '标题13', value: 13 },
              { label: '标题14', value: 14 },
              { label: '标题15', value: 15 },
              { label: '标题16', value: 16 },
              { label: '标题17', value: 17 },
              { label: '标题18', value: 18 },
              { label: '标题19', value: 19 },
              { label: '标题20', value: 20 },
              { label: '标题21', value: 21 },
              { label: '标题22', value: 22 },
              { label: '标题23', value: 23 },
              { label: '标题24', value: 24 },
              { label: '标题25', value: 25 },
            ]
          }
        },
        { title: '数量', key: 'count', align: 'center', width: 170,
          filterColumn: {
            slotName: 'countSlot',
            keys: ['count1', 'count2'],
            showTitle: false
          }
        },
        { title: '姓名', key: 'name', align: 'center', width: 150,
          filterColumn: {
            name: 'el-select',
            filterable: true,
            multiple: true,
            options: () =&gt; this.asyncList
          }
        },
        { title: '下拉类型', key: 'name2', align: 'center', width: 150,
          filterColumn: {
            name: 'el-select',
            options: [
              { label: '1', value: 1 },
              { label: '0', value: 0 },
              { label: 'true', value: true },
              { label: 'false', value: false },
            ]
          }
        },
        { title: '地址', key: 'address', align: 'center', width: 150,
          filterColumn: {
            name: 'el-input',
            customMethod: (key, val) =&gt; {
              console.log(key, val)
            }
          }
        }
      ]
    }
  },
  methods: {
    resetSearchValue() {
      this.$refs.apexTable.clearFilterColumnValue()
      this.$refs.apexTable.filterColumn(null, '', '')
    },
    asyncGetData() {
      this.tableLoading = true
      setTimeout(() =&gt; {
        this.$message.success('请求成功')
        this.asyncList = [
          { label: '詹姆斯', value: '詹姆斯' },
          { label: '安东尼', value: '安东尼' },
          { label: '奥尼尔', value: '奥尼尔' },
          { label: '杜兰特', value: '杜兰特' }
        ]
        this.tableLoading = false
      }, 1500)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>高级查询</h3>
<p>适用于需要拓展的高级查询</p>
<demo-block>
        <div><p>在<code>toolbar</code>中设置<code>advancedSearch</code>属性开启高级查询组件，该属性可以是一个布尔值或对象，设置<code>advancedSearch.operatorList</code>和<code>advancedSearch.andOrList</code>来设置操作符下拉和连接符下拉选项，其他用法示例如下：</p>
</div>
        <template slot="source"><element-demo13 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  ref=&quot;apexTable&quot;
  header-bgc
  :loading=&quot;tableLoading&quot;
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :header-operations=&quot;headerOperations&quot;
  :toolbar=&quot;toolbarOptions&quot;
  @clearQueryAll=&quot;clearQueryAll&quot;
  @advanced-search-expand-change=&quot;advancedSearchExpandChange&quot;
  @advanced-search=&quot;testCallback&quot;
  @advanced-search-reset=&quot;testCallback&quot;
  @advanced-search-delete-template=&quot;testCallback&quot;
  @advanced-search-save-template=&quot;testCallback&quot;
  @advanced-search-set-as-default-template=&quot;testCallback&quot;
  @advanced-search-click-template=&quot;handleClickTemplate&quot;
  @advanced-search-field-change=&quot;fieldChange&quot;
&gt;
  &lt;template v-slot:countNumslot=&quot;{ scope }&quot;&gt;
    &lt;span&gt;{{ scope.title }} - slot自定义标题&lt;/span&gt;
    &lt;div class=&quot;apex-table-header-slot&quot;&gt;
      &lt;el-input v-model=&quot;scope.filterColumnObj[scope.filterColumn.keys[0]]&quot; placeholder=&quot;插槽示例&quot;&gt;&lt;/el-input&gt;
      &lt;span&gt;-&lt;/span&gt;
      &lt;el-input v-model=&quot;scope.filterColumnObj[scope.filterColumn.keys[1]]&quot; placeholder=&quot;插槽示例&quot;&gt;&lt;/el-input&gt;
    &lt;/div&gt;
  &lt;/template&gt;
&lt;/apex-table&gt;

&lt;script&gt;
export default {
  data() {
    return {
      tableLoading: false,
      headerOperations: [
        { text: '清空所有条件(包括高级查询的)', type: 'primary', emit: 'clearQueryAll' }
      ],
      toolbarOptions: {
        storage: 'toolbar-reset-table',
        reset: true,
        advancedSearch: true
      },
      data: [
        { date: '2022-06-12', count: 111, name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' },
        { date: '2022-06-14', count: 222, name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' },
        { date: '2022-06-11', count: 123, name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' },
        { date: '2022-06-13', count: 356, name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      columns: [
        { title: '日期', key: 'date', align: 'center', width: 250,
          filterColumn: {
            name: 'el-date-picker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '开始日期',
            'end-placeholder': '结束日期',
            keys: ['datetime'] // key别名，传给后台用的 不填默认为列的key
          }
        },
        { title: '数量', key: 'count', align: 'center',
          filterColumn: {
            slotName: 'countNumslot',
            keys: ['count1', 'count2'],
            showTitle: false
          }
        },
        { title: '姓名', key: 'name', align: 'center', width: 120,
          filterColumn: {
            name: 'el-select',
            filterable: true,
            multiple: true,
            options: [
              { label: '詹姆斯', value: '詹姆斯' },
              { label: '安东尼', value: '安东尼' },
              { label: '奥尼尔', value: '奥尼尔' },
              { label: '杜兰特', value: '杜兰特' }
            ]
          }
        },
        { title: '地址', key: 'address', align: 'center',
          filterColumn: {
            name: 'el-input',
            customMethod: (key, val) =&gt; {
              console.log(key, val)
            }
          }
        }
      ]
    }
  },
  methods: {
    clearQueryAll() {
      this.$refs.apexTable.clearFilterColumnValue()
      this.$refs.apexTable.filterColumn(null, '', '')
      this.$refs.apexTable.advancedSearchClearAll()
    },
    advancedSearchExpandChange({ expanded, loading }) {
      if (loading) {
        // 这里可以写调接口等逻辑
        setTimeout(() =&gt; {
          this.$message.success('请求成功')
          const res1 = [
            { key: 'key_1', text: '输入框', type: '0' },
            { key: 'key_2', text: '日期框', type: '1' },
            { key: 'key_3', text: '下拉框', type: '2', searchField: 'CR' },
            { key: 'key_4', text: '下拉框（多选）', type: '3', searchField: 'PORT' },
          ]
          const res2 = [
            { name: 'Amazon Group', id: 1, isDefault: 0 },
            { name: 'Amazon Group2222', id: 2, isDefault: 0 },
            { name: 'Amazon Group3333', id: 3, isDefault: 1 },
            { name: 'Amazon Group-test-2022-07-19 Group-test-2022-07-19', id: 4, isDefault: 0 },
            { name: 'Amazon Group', id: 5, isDefault: 0 },
            { name: 'Amazon Group', id: 6, isDefault: 0 },
            { name: '123', id: 7, isDefault: 0 },
            { name: '345', id: 8, isDefault: 0 },
            { name: '456', id: 9, isDefault: 0 }
          ]
          this.$refs.apexTable.advancedSearchSetFieldsList(res1)
          this.$refs.apexTable.advancedSearchSetTemplateList(res2, true) // 展开的时候需要传true选中默认模板
          this.$refs.apexTable.advancedSearchSetLoading(false)
        }, 1000)
      }
    },
    // 模拟示例  方法可分开
    testCallback(data) {
      console.log(data)
    },
    // 请求下拉的接口
    fieldChange(row) {
      console.log(row)
      this.$refs.apexTable.advancedSearchSetLoading(true)
      setTimeout(() =&gt; {
        this.$message.success('请求成功')
        this.$refs.apexTable.advancedSearchSetLoading(false)
        const res = [
          { label: '标题1', value: 1 },
          { label: '标题2', value: 2 },
          { label: '标题3', value: 3 },
          { label: '标题4', value: 4 },
          { label: '标题5', value: 5 },
          { label: '标题6', value: 6 },
          { label: '标题7', value: 7 },
          { label: '标题8', value: 8 },
          { label: '标题9', value: 9 },
          { label: '标题10', value: 10 },
          { label: '标题11', value: 11 },
          { label: '标题12', value: 12 },
          { label: '标题13', value: 13 },
          { label: '标题14', value: 14 },
          { label: '标题15', value: 15 },
          { label: '标题16', value: 16 },
          { label: '标题17', value: 17 },
          { label: '标题18', value: 18 },
          { label: '标题19', value: 19 },
          { label: '标题20', value: 20 },
          { label: '标题21', value: 21 },
          { label: '标题22', value: 22 },
          { label: '标题23', value: 23 },
          { label: '标题24', value: 24 },
          { label: '标题25', value: 25 },
        ]
        this.$refs.apexTable.advancedSearchSetSelectList(row.searchField, res)
      }, 1000)
    },
    // 点击查询template搜索条件
    handleClickTemplate({ id }) {
      this.$refs.apexTable.advancedSearchSetLoading(true)
      const res = [
          {
              &quot;andOr&quot;: &quot;and&quot;,
              &quot;innerList&quot;: [
                  {
                      &quot;andOr&quot;: &quot;and&quot;,
                      &quot;field&quot;: &quot;key_1&quot;,
                      &quot;operator&quot;: &quot;=&quot;,
                      &quot;value&quot;: &quot;New&quot;
                  },
                  {
                      &quot;andOr&quot;: &quot;and&quot;,
                      &quot;field&quot;: &quot;key_4&quot;,
                      &quot;operator&quot;: &quot;=&quot;,
                      &quot;value&quot;: [2, 4]
                  },
                  {
                      &quot;andOr&quot;: &quot;and&quot;,
                      &quot;field&quot;: &quot;key_3&quot;,
                      &quot;operator&quot;: &quot;=&quot;,
                      &quot;value&quot;: 8
                  }
              ]
          }
      ]
      setTimeout(() =&gt; {
        this.$message.success('请求成功')
        this.$refs.apexTable.advancedSearchSetQueryList(res)
        this.$refs.apexTable.advancedSearchSetLoading(false)
      }, 1000)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>高级查询 - Customer Select</h3>
<p>在表格高级查询中使用 Customer Select 组件进行客户筛选。</p>
<demo-block>
        <div><p>当高级查询的字段配置中，<code>type</code> 为 '2'（单选）或 '3'（多选），且 <code>searchField</code> 为 'CR' 时，会自动使用 CustomerSelect 组件。组件支持本地搜索过滤，最多显示50条数据以优化性能。</p>
</div>
        <template slot="source"><element-demo14 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  ref=&quot;refCustomerTable&quot;
  header-bgc
  :loading=&quot;tableLoading&quot;
  :columns=&quot;columns&quot;
  :data=&quot;tableData&quot;
  :toolbar=&quot;toolbarOptions&quot;
  @advanced-search-expand-change=&quot;advancedSearchExpandChange&quot;
  @advanced-search=&quot;handleAdvancedSearch&quot;
  @advanced-search-reset=&quot;handleAdvancedSearchReset&quot;
  @advanced-search-field-change=&quot;fieldChange&quot;
  @advanced-search-delete-template=&quot;handleDeleteTemplate&quot;
  @advanced-search-save-template=&quot;handleSaveTemplate&quot;
  @advanced-search-set-as-default-template=&quot;handleSetAsDefaultTemplate&quot;
  @advanced-search-click-template=&quot;handleClickTemplate&quot;
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      tableLoading: false,
      toolbarOptions: {
        storage: 'toolbar-customer-select-table',
        reset: true,
        advancedSearch: true
      },
      columns: [
        { title: 'Order ID', key: 'orderId', width: 150, align: 'center' },
        { title: 'Customer Code', key: 'customerCode', width: 200, align: 'center' },
        { title: 'Customer Name', key: 'customerName', width: 200, align: 'center' },
        { title: 'Product', key: 'product', width: 200, align: 'center' },
        { title: 'Amount', key: 'amount', width: 120, align: 'center' },
        { title: 'Status', key: 'status', width: 120, align: 'center' },
        { title: 'Order Date', key: 'orderDate', align: 'center' }
      ],
      tableData: [
        { orderId: 'ORD001', customerCode: 'AMAZON-US-001', customerName: 'Amazon US', product: 'Laptop', amount: '$1200', status: 'Completed', orderDate: '2024-01-15' },
        { orderId: 'ORD002', customerCode: 'WALMART-US-001', customerName: 'Walmart US', product: 'Phone', amount: '$800', status: 'Pending', orderDate: '2024-01-16' },
        { orderId: 'ORD003', customerCode: 'AMAZON-UK-002', customerName: 'Amazon UK', product: 'Tablet', amount: '$500', status: 'Completed', orderDate: '2024-01-17' },
        { orderId: 'ORD004', customerCode: 'EBAY-US-001', customerName: 'eBay US', product: 'Monitor', amount: '$300', status: 'Shipped', orderDate: '2024-01-18' },
        { orderId: 'ORD005', customerCode: 'SHOPIFY-CA-001', customerName: 'Shopify CA', product: 'Keyboard', amount: '$150', status: 'Completed', orderDate: '2024-01-19' },
        { orderId: 'ORD006', customerCode: 'AMAZON-DE-003', customerName: 'Amazon DE', product: 'Mouse', amount: '$50', status: 'Pending', orderDate: '2024-01-20' }
      ]
    }
  },
  methods: {
    // 高级搜索展开/折叠时触发
    advancedSearchExpandChange({ expanded, loading }) {
      if (loading) {
        // 模拟请求字段列表和模板列表
        setTimeout(() =&gt; {
          this.$message.success('数据加载成功')
          
          // 设置高级搜索字段列表
          const fieldsList = [
            { key: 'orderId', text: 'Order ID', type: '0' }, // 文本输入
            { key: 'customerSingle', text: 'Customer (Single)', type: '2', searchField: 'CR' }, // 单选客户 - CustomerSelect
            { key: 'customerMultiple', text: 'Customer (Multiple)', type: '3', searchField: 'CR' }, // 多选客户 - CustomerSelect
            { key: 'product', text: 'Product', type: '0' }, // 文本输入
            { key: 'status', text: 'Status', type: '2', searchField: 'STATUS' }, // 普通单选下拉
            { key: 'orderDate', text: 'Order Date', type: '1' } // 日期选择
          ]
          
          // 设置模板列表（可选）
          const templateList = [
            { name: 'Amazon Orders', id: 1, isDefault: 1 },
            { name: 'Pending Orders', id: 2, isDefault: 0 },
            { name: 'High Value Orders', id: 3, isDefault: 0 }
          ]
          
          this.$refs.refCustomerTable.advancedSearchSetFieldsList(fieldsList)
          this.$refs.refCustomerTable.advancedSearchSetTemplateList(templateList, true)
          this.$refs.refCustomerTable.advancedSearchSetLoading(false)
        }, 1000)
      }
    },
    
    // 字段改变时触发（用于请求下拉选项数据）
    fieldChange(row) {
      console.log('Field changed:', row)
      this.$refs.refCustomerTable.advancedSearchSetLoading(true)
      
      setTimeout(() =&gt; {
        this.$message.success('选项数据加载成功')
        
        // 根据不同的 searchField 返回不同的数据
        if (row.searchField === 'CR') {
          // Customer 数据 - 注意格式必须包含 label, value, customerId, groupId
          // 使用循环生成2000条模拟数据，测试最多显示50条的效果
          const platforms = ['AMAZON', 'WALMART', 'EBAY', 'SHOPIFY', 'TARGET', 'BESTBUY', 'ALIEXPRESS', 'RAKUTEN', 'LAZADA', 'SHOPEE']
          const countries = ['US', 'UK', 'DE', 'FR', 'JP', 'CA', 'AU', 'IT', 'ES', 'IN', 'SG', 'MY', 'TH', 'PH', 'VN', 'ID', 'TW', 'BR', 'MX', 'AR']
          const customerData = []
          
          for (let i = 1; i &lt;= 2000; i++) {
            const platform = platforms[i % platforms.length]
            const country = countries[i % countries.length]
            const num = String(i).padStart(3, '0')
            customerData.push({
              label: `${platform}-${country}-${num}`,
              value: `${platform}-${country}-${num}`,
              customerId: `CUS${num}`,
              groupId: `GRP${String(Math.floor(i / 10) + 1).padStart(3, '0')}`
            })
          }
          
          this.$refs.refCustomerTable.advancedSearchSetSelectList(row.searchField, customerData)
        } else if (row.searchField === 'STATUS') {
          // Status 普通下拉数据
          const statusData = [
            { label: 'Pending', value: 'Pending' },
            { label: 'Completed', value: 'Completed' },
            { label: 'Shipped', value: 'Shipped' },
            { label: 'Cancelled', value: 'Cancelled' }
          ]
          this.$refs.refCustomerTable.advancedSearchSetSelectList(row.searchField, statusData)
        }
        
        this.$refs.refCustomerTable.advancedSearchSetLoading(false)
      }, 500)
    },
    
    // 点击搜索按钮
    handleAdvancedSearch(queryList) {
      console.log('Advanced search:', queryList)
      this.$message.success('执行高级搜索')
      // 这里可以根据 queryList 调用接口查询数据
    },
    
    // 点击重置按钮
    handleAdvancedSearchReset(queryList) {
      console.log('Reset search:', queryList)
      this.$message.info('重置搜索条件')
    },
    
    // 删除模板
    handleDeleteTemplate(template) {
      console.log('Delete template:', template)
      this.$message.success('模板删除成功')
    },
    
    // 保存模板
    handleSaveTemplate(data) {
      console.log('Save template:', data)
      this.$message.success('模板保存成功')
    },
    
    // 设置为默认模板
    handleSetAsDefaultTemplate(template) {
      console.log('Set as default:', template)
      this.$message.success('设置默认模板成功')
    },
    
    // 点击模板
    handleClickTemplate(template) {
      console.log('Click template:', template)
      this.$refs.refCustomerTable.advancedSearchSetLoading(true)
      
      // 模拟加载模板对应的查询条件
      setTimeout(() =&gt; {
        const queryList = [
          {
            andOr: 'and',
            innerList: [
              { andOr: 'and', field: 'customerSingle', operator: '=', value: 'AMAZON-US-001' },
              { andOr: 'and', field: 'status', operator: '=', value: 'Completed' }
            ]
          }
        ]
        this.$refs.refCustomerTable.advancedSearchSetQueryList(queryList)
        this.$refs.refCustomerTable.advancedSearchSetLoading(false)
      }, 500)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>排序</h3>
<p>对表格进行排序，可快速查找或对比数据。</p>
<demo-block>
        <div><p>在<code>columns</code>中设置<code>sortable</code>属性即为<code>true</code>可实现以该列为基准的排序，接受一个<code>Boolean</code>，默认为<code>false</code>。可以通过<code>options</code>的<code>defaultSort</code>属性设置默认的排序列和排序顺序。可以使用<code>sort-method</code>或者<code>sort-by</code>使用自定义的排序规则。如果需要后端排序，需将<code>sortable</code>设置为<code>custom</code>，同时在 Table 上监听<code>sort-change</code>事件，在事件回调中可以获取当前排序的字段名和排序顺序，从而向接口请求排序后的表格数据。示例如下：</p>
</div>
        <template slot="source"><element-demo15 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table
  :toolbar=&quot;{ refresh: false }&quot;
  :columns=&quot;columns&quot;
  :data=&quot;data&quot;
  :options=&quot;options&quot;
/&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200, sortable: true },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' },
        { title: '爱好', key: 'liked' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄', liked: '篮球' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄', liked: '足球' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄', liked: '羽毛球' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄', liked: '游泳' }
      ],
      options: {
        defaultSort: {prop: 'date', order: 'descending'}
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>formatter格式化</h3>
<p>用来格式化内容。</p>
<demo-block>
        <div><p>在<code>columns</code>对象里添加<code>formatter</code>属性用来格式化单元格内容，类型<code>Function</code>，回调参数<code>(row, column, cellValue, index)</code>。</p>
</div>
        <template slot="source"><element-demo16 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 120 },
        { title: '姓名', key: 'name', width: 120 },
        {
          title: '性别',
          key: 'gender',
          width: 120,
          formatter: (row, column, cellValue, index) =&gt; {
            return cellValue === 1 ? '男' : cellValue === 2 ? '女' : '未知'
          }
        },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', gender: 1, name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', gender: 2, name: '蕾欧娜', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', gender: 1, name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', gender: null, name: '大司马', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', gender: 2, name: '刘亦菲', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>自定义索引（行序号）</h3>
<p>分页序号连续。</p>
<demo-block>
        <div><p>在<code>apex-table</code>组件中传入<code>indexRow</code>即可开启表格序号展示，当分页时需要让序号连续可设置<code>indexRow.continuous</code>为<code>true</code>，默认为<code>false</code>。如需不按顺序、自定义序号，也可设置<code>indexRow.index</code>函数来自定义序号值。</p>
</div>
        <template slot="source"><element-demo17 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :index-row=&quot;indexRow&quot; :options=&quot;options&quot; :pagination=&quot;pagination&quot; client-pagination /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      indexRow: {
        title: '序号',
        continuous: true
      },
      options: {
        height: '300px'
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>带斑马纹表格</h3>
<demo-block>
        <div><p><code>options</code>对象可以对表格进行配置，其中<code>stripe</code>属性可以创建带斑马纹的表格。它接受一个<code>Boolean</code>，设置为<code>true</code>即为启用。</p>
</div>
        <template slot="source"><element-demo18 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :options=&quot;options&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        stripe: true
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>带状态表格</h3>
<demo-block>
        <div><p>可以通过指定<code>apex-table</code>组件<code>options</code>对象中的<code>rowClassName</code>属性来为<code>apex-table</code>中的某一行添加<code>class</code>，表明该行处于某种状态。</p>
</div>
        <template slot="source"><element-demo19 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :options=&quot;options&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        rowStyle ({row, rowIndex}) {
          if (rowIndex === 1) {
            return { background: 'oldlace' }
          } else if (rowIndex === 3) {
            return { background: '#f0f9eb' }
          }
        }
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>固定表头</h3>
<demo-block>
        <div><p>只要在<code>options</code>对象中定义了<code>height</code>属性，即可实现固定表头的表格，而不需要额外的代码。</p>
</div>
        <template slot="source"><element-demo20 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :options=&quot;options&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        height: '250'
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>固定列</h3>
<demo-block>
        <div><p>固定列需要在<code>columns</code>对象数组中给需要固定的列传入<code>fixed</code>属性，它接受<code>Boolean</code>值或者<code>left``right</code>，表示左边固定还是右边固定。</p>
</div>
        <template slot="source"><element-demo21 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 130, fixed: true },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address', width: 300 },
        { title: '爱好', key: 'liked', width: 200 },
        { title: '省份', key: 'province', width: 200 },
        { title: '市区', key: 'city', width: 200 },
        { title: '区域', key: 'county', width: 200, fixed: 'right' },
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>流体高度</h3>
<demo-block>
        <div><p>通过在<code>options</code>对象设置<code>maxHeight</code>属性为<code>apex-table</code>指定最大高度。此时若表格所需的高度大于最大高度，则会显示一个滚动条。</p>
</div>
        <template slot="source"><element-demo22 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; :options=&quot;options&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        maxHeight: '200px'
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>多级表头</h3>
<demo-block>
        <div><p>数据结构比较复杂的时候，可使用多级表头来展现数据的层次关系，只需在<code>columns</code>中使用<code>children</code>字段对子级表头进行嵌套即可。</p>
</div>
        <template slot="source"><element-demo23 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; /&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date',
          width: 130
        },
        {
          title: '配送信息',
          children: [
            {
              title: '姓名',
              key: 'name'
            },
            {
              title: '地址',
              children: [
                {
                  title: '省份',
                  key: 'province'
                },
                {
                  title: '市区',
                  key: 'city'
                },
                {
                  title: '地址',
                  key: 'address'
                }
              ]
            },
          ]
        }
      ],
      data: [
        {
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-08',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-06',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-07',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>单选</h3>
<demo-block>
        <div><p><code>apex-table</code>组件提供了单选的支持，只需要设置<code>radio-row</code>属性即可实现单选。之后由<code>current-change</code>事件来管理选中时触发的事件，它会传入<code>currentRow</code>和<code>oldCurrentRow</code>。</p>
</div>
        <template slot="source"><element-demo24 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;el-button @click=&quot;setCurrent&quot;&gt;选中第二行&lt;/el-button&gt;
    &lt;el-button @click=&quot;cancleChecked&quot;&gt;取消选中行&lt;/el-button&gt;
    &lt;apex-table
      ref=&quot;apexTable&quot;
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      radio-row
      @current-change=&quot;handleCurrentChange&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ]
    }
  },
  methods: {
    handleCurrentChange (currentRow, oldCurrentRow) {
      console.log(currentRow)
      console.log(oldCurrentRow)
    },
    setCurrent() {
      this.$refs.apexTable.setCurrentRow(1)
    },
    cancleChecked() {
      this.$refs.apexTable.setCurrentRow()
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>多选</h3>
<demo-block>
        <div><p><code>apex-table</code>组件提供了多选的支持，只需要配置<code>selection-row</code>属性即可实现多选，可以设置<code>selectionRow.isRowClick</code>为<code>true</code>来开启单击行时选中checkbox，设置<code>isBgc</code>为<code>true</code>开启选中高亮当前行，之后由<code>selection-change</code>事件来管理选择项发生变化时触发的事件，它会传入<code>selection</code>。</p>
</div>
        <template slot="source"><element-demo25 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;el-button type=&quot;primary&quot; @click=&quot;handleChoose&quot;&gt;选中第三行&lt;/el-button&gt;
    &lt;apex-table
      ref=&quot;apexTable&quot;
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :selection-row=&quot;selectionRow&quot;
      @selection-change=&quot;handleSelectionChange&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '詹姆斯',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ],
      selectionRow: {
        isRowClick: true,
        isBgc: true,
        selectable: (row, index) =&gt; {
          return row.name !== '詹姆斯'
        }
      }
    }
  },
  methods: {
    handleSelectionChange(selection) {
      console.log(selection)
    },
    handleChoose() {
      this.$refs.apexTable.toggleRowSelection(2, true)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>开启 Ctrl 和 Shift 连续多选模式</h3>
<p>用于类似于 Excel 操作，隐藏多选框列。</p>
<demo-block>
        <div><p>设置<code>selectionRow.hidden</code>为<code>true</code>时会隐藏多选框这一列，并开启ctrl(mac电脑是command键)+鼠标左键来进行多选行的操作，也可以按住shift选择头和尾进行多选。操作逻辑类似于Excel，示例如下：</p>
</div>
        <template slot="source"><element-demo26 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :selection-row=&quot;selectionRow&quot;
      @selection-change=&quot;handleSelectionChange&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2016-05-02', name: '杜兰特', address: '上海市普陀区金沙江路 1518 弄' },
        { date: '2016-05-04', name: '詹姆斯', address: '上海市普陀区金沙江路 1517 弄' },
        { date: '2016-05-01', name: '奥尼尔', address: '上海市普陀区金沙江路 1519 弄' },
        { date: '2016-05-03', name: '王小虎', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-05', name: '关云长', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-06', name: '潘神汪', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-07', name: '王五以', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-08', name: '赵六三', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-09', name: '盲僧神', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-10', name: '赵子龙', address: '上海市普陀区金沙江路 1516 弄' },
      ],
      selectionRow: {
        hidden: true
      }
    }
  },
  methods: {
    handleSelectionChange (selection) {
      console.log(selection)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>树形数据与懒加载</h3>
<demo-block>
        <div><p>支持树类型的数据的显示。当 row 中包含 <code>children</code> 字段时，被视为树形数据。渲染树形数据时，必须要指定 <code>row-key</code>。支持子节点数据异步加载。设置 Table 的 <code>lazy</code> 属性为 true 与加载函数 <code>load</code> 。通过指定 row 中的 <code>hasChildren</code> 字段来指定哪些行是包含子节点。<code>children</code> 与 <code>hasChildren</code> 都可以通过 <code>tree-props</code> 配置。</p>
</div>
        <template slot="source"><element-demo27 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;el-button type=&quot;primary&quot; @click=&quot;reset&quot;&gt;重置加载状态&lt;/el-button&gt;
&lt;apex-table 
  ref=&quot;apexTable&quot; 
  :columns=&quot;columns&quot; 
  :data=&quot;data&quot; 
  :options=&quot;options&quot; 
  :selection-row=&quot;selectionRow&quot;
  @selection-change=&quot;selectionChange&quot;
/&gt;

&lt;script&gt;
export default {
  data () {
    return {
      selectionRow: {
        isRowClick: true,
        isBgc: false,
        isTree: true,
        // selectable: (row, index) =&gt; {
        //   return row.id !== 555
        // }
      },
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          id: 1,
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          children: []
        },
        {
          id: 2,
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          id: 3,
          date: '2016-05-01',
          name: '我是懒加载1',
          address: '上海市普陀区金沙江路 1519 弄',
          hasChildren: true
        },
        {
          id: 4,
          date: '2016-05-03',
          name: '我是懒加载2',
          address: '上海市普陀区金沙江路 1516 弄',
          hasChildren: true
        },
        {
          id: 5,
          date: '2016-05-03',
          name: '王小虎5',
          address: '上海市普陀区金沙江路 1516 弄',
          children: [
            {
              id: 55,
              date: '2016-05-55',
              name: '王小虎55',
              address: '上海市普陀区金沙江路 1516 弄',
              children: [
                {
                  id: 555,
                  date: '2016-05-55',
                  name: '王小虎555',
                  address: '上海市普陀区金沙江路 1516 弄',
                },
                {
                  id: 556,
                  date: '2016-05-55',
                  name: '王小虎556',
                  address: '上海市普陀区金沙江路 1516 弄',
                }
              ]
            }
          ]
        }
      ],
      options: {
        rowKey: 'id',
        lazy: true,
        load: this.load
      }
    }
  },
  methods: {
    reset() {
      this.$refs.apexTable.resetAllExpandRowStatus()
    },
    load(row, treeNode, resolve) {
      if (row.id === 3) {
          setTimeout(() =&gt; {
            const res = [
              {
                id: 31,
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
              }, {
                id: 32,
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
              }
            ]
            this.$refs.apexTable.lazyLoadNodeAssociat(row, res)
            resolve(res)
        }, 1000)
      } else if (row.id === 4) {
        setTimeout(() =&gt; {
          const res = [
            {
              id: 41,
              date: '2016-05-01',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 42,
              date: '2016-05-01',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }
          ]
          this.$refs.apexTable.lazyLoadNodeAssociat(row, res)
          resolve(res)
        }, 1000)
      }
    },
    selectionChange(selection) {
      console.log(selection)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>筛选</h3>
<demo-block>
        <div><p>在<code>columns</code>中设置<code>filters``filterMethod</code>属性即可开启该列的筛选，<code>filters</code>是一个数组，<code>filterMethod</code>是一个方法，它用于决定某些数据是否显示，会传入三个参数：<code>value</code>,<code>row</code>和<code>column</code>。</p>
</div>
        <template slot="source"><element-demo28 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: '标签',
          key: 'tag',
          filters: [
            { text: '家', value: '家' },
            { text: '公司', value: '公司' }
          ],
          filterMethod (value, row) {
            return row.tag === value
          },
          filterPlacement: 'bottom-end'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          tag: '家'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          tag: '公司'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          tag: '家'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          tag: '公司'
        }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>表尾合计行</h3>
<demo-block>
        <div><p>将<code>options</code>中的<code>showSummary</code>设置为<code>true</code>就会在表格尾部展示合计行。默认情况下，对于合计行，第一列不进行数据求合操作，而是显示「合计」二字（可通过<code>sumText</code>配置），其余列会将本列所有数值进行求合操作，并显示出来。当然，你也可以定义自己的合计逻辑。使用<code>summaryMethod</code>并传入一个方法，返回一个数组，这个数组中的各项就会显示在合计行的各列中。</p>
</div>
        <template slot="source"><element-demo29 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :options=&quot;options&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '数值 1',
          key: 'amount1'
        },
        {
          title: '数值 2',
          key: 'amount2'
        },
        {
          title: '数值 3',
          key: 'amount3'
        }
      ],
      data: [
        {
          id: '12987122',
          name: '王小虎',
          amount1: '234',
          amount2: '3.2',
          amount3: 10
        },
        {
          id: '12987123',
          name: '王小虎',
          amount1: '165',
          amount2: '4.43',
          amount3: 12
        },
        {
          id: '12987124',
          name: '王小虎',
          amount1: '324',
          amount2: '1.9',
          amount3: 9
        },
        {
          id: '12987125',
          name: '王小虎',
          amount1: '621',
          amount2: '2.2',
          amount3: 17
        },
        {
          id: '12987126',
          name: '王小虎',
          amount1: '539',
          amount2: '4.1',
          amount3: 15
        }
      ],
      options: {
        showSummary: true,
        summaryMethod (param) {
          const { columns, data } = param
          const sums = []
          columns.forEach((column, index) =&gt; {
            if (index === 0) {
              sums[index] = '总价'
              return
            }
            const values = data.map(item =&gt; Number(item[column.property]))
            if (!values.every(value =&gt; isNaN(value))) {
              sums[index] = values.reduce((prev, curr) =&gt; {
                const value = Number(curr)
                if (!isNaN(value)) {
                  return prev + curr
                } else {
                  return prev
                }
              }, 0)
              sums[index] += ' 元'
            } else {
              sums[index] = 'N/A'
            }
          })

          return sums
        }
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>合并行</h3>
<demo-block>
        <div><p>通过给<code>options</code>传入<code>spanMethod</code>方法可以实现合并行，方法的参数是一个对象，里面包含当前行<code>row</code>、当前列<code>column</code>、当前行号<code>rowIndex</code>、当前列号<code>columnIndex</code>四个属性。该函数可以返回一个包含两个元素的数组，第一个元素代表<code>rowspan</code>，第二个元素代表<code>colspan</code>。</p>
</div>
        <template slot="source"><element-demo30 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :options=&quot;options&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '数值 1',
          key: 'amount1'
        },
        {
          title: '数值 2',
          key: 'amount2'
        },
        {
          title: '数值 3',
          key: 'amount3'
        }
      ],
      data: [
        {
          id: '12987122',
          name: '王小虎',
          amount1: '234',
          amount2: '3.2',
          amount3: 10
        },
        {
          id: '12987123',
          name: '王小虎',
          amount1: '165',
          amount2: '4.43',
          amount3: 12
        },
        {
          id: '12987124',
          name: '王小虎',
          amount1: '324',
          amount2: '1.9',
          amount3: 9
        },
        {
          id: '12987125',
          name: '王小虎',
          amount1: '621',
          amount2: '2.2',
          amount3: 17
        },
        {
          id: '12987126',
          name: '王小虎',
          amount1: '539',
          amount2: '4.1',
          amount3: 15
        }
      ],
      options: {
        border: true,
        spanMethod ({ row, column, rowIndex, columnIndex }) {
          if (rowIndex % 2 === 0) {
            if (columnIndex === 0) {
              return [1, 2]
            } else if (columnIndex === 1) {
              return [0, 0]
            }
          }
        }
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>合并列</h3>
<demo-block>
        <div><p>通过给<code>options</code>传入<code>spanMethod</code>方法可以实现合并行，方法的参数是一个对象，里面包含当前行<code>row</code>、当前列<code>column</code>、当前行号<code>rowIndex</code>、当前列号<code>columnIndex</code>四个属性。该函数可以返回一个键名为<code>rowspan</code>和<code>colspan</code>的对象。</p>
</div>
        <template slot="source"><element-demo31 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :options=&quot;options&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '数值 1',
          key: 'amount1'
        },
        {
          title: '数值 2',
          key: 'amount2'
        },
        {
          title: '数值 3',
          key: 'amount3'
        }
      ],
      data: [
        {
          id: '12987122',
          name: '王小虎',
          amount1: '234',
          amount2: '3.2',
          amount3: 10
        },
        {
          id: '12987123',
          name: '王小虎',
          amount1: '165',
          amount2: '4.43',
          amount3: 12
        },
        {
          id: '12987124',
          name: '王小虎',
          amount1: '324',
          amount2: '1.9',
          amount3: 9
        },
        {
          id: '12987125',
          name: '王小虎',
          amount1: '621',
          amount2: '2.2',
          amount3: 17
        },
        {
          id: '12987126',
          name: '王小虎',
          amount1: '539',
          amount2: '4.1',
          amount3: 15
        }
      ],
      options: {
        border: true,
        spanMethod ({ row, column, rowIndex, columnIndex }) {
          if (columnIndex === 0) {
            if (rowIndex % 2 === 0) {
              return {
                rowspan: 2,
                colspan: 1
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
        }
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>分页</h3>
<demo-block>
        <div><p>在<code>apex-table</code>组件中传入<code>pagination</code>对象即可开启分页，可设置<code>lt-one-page</code>属性控制是否开启当总条数小于一页时不显示分页。</p>
</div>
        <template slot="source"><element-demo32 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :pagination=&quot;pagination&quot;
      @pagination-current-change=&quot;paginationCurrentChange&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        { title: 'ID', key: 'id' },
        { title: '姓名', key: 'name' },
        { title: '数值 1', key: 'amount1' },
        { title: '数值 2', key: 'amount2' },
        { title: '数值 3', key: 'amount3' }
      ],
      data: [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10 },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12 },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9 },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17 },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  methods: {
    paginationCurrentChange (currentPage) {
      // 切换页数逻辑
      this.pagination.currentPage = currentPage
      // this.fetchData()
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>客户端分页</h3>
<demo-block>
        <div><p>在<code>apex-table</code>组件中传入<code>client-pagination</code>即可开启客户端分页。</p>
</div>
        <template slot="source"><element-demo33 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;el-button type=&quot;primary&quot; @click=&quot;resetData&quot;&gt;重新加载数据，重置客户端分页当前页&lt;/el-button&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :pagination=&quot;pagination&quot;
      client-pagination
    /&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        { title: 'ID', key: 'id' },
        { title: '姓名', key: 'name' },
        { title: '数值 1', key: 'amount1' },
        { title: '数值 2', key: 'amount2' },
        { title: '数值 3', key: 'amount3' }
      ],
      data: [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10 },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12 },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9 },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17 },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987127', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987128', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987129', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987110', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987111', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987112', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987113', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987114', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987115', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987116', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987117', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987118', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987119', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987120', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987121', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987122', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987123', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
        layout: 'sizes, prev, pager, next, jumper, -&gt;, total, slot',
        pageSizes: [5, 10, 30, 40, 50, 100]
      }
    }
  },
  methods: {
    resetData() {
      this.data = [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10 },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12 },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9 },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17 },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987127', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987128', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987129', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987110', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987111', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987112', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987113', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987114', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987115', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987116', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987117', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987118', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987119', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987120', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987121', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987122', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>展开行（嵌套表格）</h3>
<demo-block>
        <div><p>通过设置<code>columns</code>的<code>type: 'expand'</code>开启展开行功能。展开与收起触发回调函数<code>expand-change</code>，示例如下：</p>
</div>
        <template slot="source"><element-demo34 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :options=&quot;{ height: 400 }&quot;
      @expand-change=&quot;onExpandChange&quot;
    &gt;
      &lt;template v-slot:expandSlot=&quot;{ scope }&quot;&gt;
        &lt;apex-table :columns=&quot;columns2&quot; :data=&quot;scope.row.tableData&quot; /&gt;
      &lt;/template&gt;
    &lt;/apex-table&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns2: [
        { title: '日期', key: 'date', width: 300 },
        { title: '姓名', key: 'name', width: 300 },
        { title: '地址', key: 'address1', width: 300 },
        { title: '地址', key: 'address2', width: 300 },
        { title: '地址', key: 'address3', width: 300 },
        { title: '地址', key: 'address4', width: 300 },
        { title: '地址', key: 'address5', width: 300 },
        { title: '地址', key: 'address6', width: 300 },
        { title: '地址', key: 'address7', width: 300 },
        { title: '地址', key: 'address8', width: 300 },
        { title: '地址', key: 'address9', width: 300 }
      ],
      columns: [
        {
          type: 'expand',
          slotName: 'expandSlot'
        },
        { title: 'ID', key: 'id', width: 200, fixed: 'left' },
        { title: '姓名', key: 'name', width: 300 },
        { title: '数值 1', key: 'amount1', width: 300 },
        { title: '数值 2', key: 'amount2', width: 300 },
        { title: '数值 3', key: 'amount3', width: 300 },
        { title: '数值 1', key: 'amount4', width: 300 },
        { title: '数值 2', key: 'amount5', width: 300 },
        { title: '数值 3', key: 'amount6', width: 300 },
        { title: '数值 1', key: 'amount7', width: 300 },
        { title: '数值 2', key: 'amount8', width: 300 },
        { title: '数值 3', key: 'amount9', width: 300 },
        { title: '数值 1', key: 'amount10', width: 300 },
        { title: '数值 2', key: 'amount11', width: 300 },
        { title: '数值 3', key: 'amount12', width: 300 },
      ],
      data: [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10,
          tableData: [
            { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
            { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
            { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
            { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
          ]
        },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12, tableData: [] },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9, tableData: [] },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
      ]
    }
  },
  methods: {
    onExpandChange(row, expandRows) {
      console.log(row, expandRows)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>删除数据</h3>
<demo-block>
        <div><p>通过给<code>apex-table</code>传入<code>rowHandle</code>可开启表格操作列，传入<code>remove</code>对象可以开启删除模式，<code>confirm</code>属性的值为<code>Boolean</code>类型，控制删除前是否弹出confirm框进行提示，<code>row-remove</code>事件控制数据删除，参数：<code>index</code>是当前删除行的索引，<code>row</code>是当前删除行的数据，<code>done</code>用于控制删除成功，可以在<code>done()</code>之前加入自己的逻辑代码。</p>
</div>
        <template slot="source"><element-demo35 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :row-handle=&quot;rowHandle&quot;
      @row-remove=&quot;handleRowRemove&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          forbidRemove: true,
          showRemoveButton: true
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          forbidRemove: false,
          showRemoveButton: true
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          forbidRemove: false,
          showRemoveButton: false
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          forbidRemove: false,
          showRemoveButton: true
        }
      ],
      rowHandle: {
        remove: {
          icon: 'el-icon-delete',
          size: 'small',
          fixed: 'right',
          confirm: true,
          show (index, row) {
            if (row.showRemoveButton) {
              return true
            }
            return false
          },
          disabled (index, row) {
            if (row.forbidRemove) {
              return true
            }
            return false
          }
        }
      }
    }
  },
  methods: {
    handleRowRemove({ index, row }, done) {
      setTimeout(() =&gt; {
        console.log(index)
        console.log(row)
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        done()
      }, 300)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>自定义操作列</h3>
<demo-block>
        <div><p>通过给<code>apex-table</code>传入<code>rowHandle</code>可开启表格操作列，传入<code>custom</code>数组对象可以自定义模式，数组中每一个对象定义一个自定义按钮，对象属性支持所有的<code>el-button</code>属性，<code>emit</code>属性定义了监听的事件，例如<code>emit</code>的值为<code>custom-emit-1</code>，就在<code>apex-table</code>中监听<code>custom-emit-1</code>事件监听的事件参数：<code>index</code>是当前行的索引，<code>row</code>是当前行的数据。</p>
</div>
        <template slot="source"><element-demo36 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      :row-handle=&quot;rowHandle&quot;
      @custom-emit-1=&quot;handleCustomEvent&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ],
      rowHandle: {
        custom: [
          {
            text: '自定义按钮',
            type: 'warning',
            size: 'small',
            emit: 'custom-emit-1'
          }
        ]
      }
    }
  },
  methods: {
    handleCustomEvent({index, row}) {
      console.log(index)
      console.log(row)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>表格内编辑</h3>
<demo-block>
        <div><p>向<code>columns</code>的<code>component</code>对象传入<code>name</code>属性来控制渲染的组件，默认为<code>el-input</code>，支持的组件有<code>el-input-number</code>、<code>el-radio</code>、<code>el-checkbox</code>、<code>el-select</code>、<code>el-cascader</code>、<code>el-switch</code>、<code>el-slider</code>、<code>el-time-select</code>、<code>el-time-picker</code>、<code>el-date-picker</code>、<code>el-rate</code>、<code>el-color-picker</code>，也可以使用<code>render函数</code>自己渲染组件，只需在<code>component</code>中传入<code>renderFuntion</code>，接收两个参数：<code>h</code>是render函数的固定参数，<code>scope</code>是单元格中的数据，<a href="https://cn.vuejs.org/v2/guide/render-function.html">render函数使用方法</a>。通过<code>cell-data-change</code>事件可以监听单元格内的数据变化，监听在apex-table内部是通过change事件触发的（这意味着input类组件失去焦点才会触发事件，单纯输入不会触发），接收一个对象参数<code>{rowIndex, key, value, row}</code>，<code>rowIndex</code>为改变所在行，<code>key</code>为改变的字段，<code>value</code>为改变后的值，<code>row</code>是改变所在行的所有数据。</p>
</div>
        <template slot="source"><element-demo37 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;apex-table
      :columns=&quot;columns&quot;
      :data=&quot;data&quot;
      @cell-data-change=&quot;handleCellDataChange&quot;/&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        { title: '日期', key: 'date', align: 'center',
          component: {
            name: 'el-date-picker',
            size: 'small'
          }
        },
        { title: '姓名', key: 'name', align: 'center',
          component: {
            name: 'el-select',
            options: [
              {
                value: '王小虎',
                label: '王小虎'
              },
              {
                value: '王中虎',
                label: '王中虎'
              },
              {
                value: '王老虎',
                label: '王老虎'
              }
            ],
            size: 'small'
          }
        },
        { title: '地址', key: 'address', align: 'center',
          component: {
            name: 'el-input',
            size: 'small',
            float: 4,
            keyup: ({ row, rowIndex, key, value }) =&gt; {
              this.keyupTest(row)
            }
          }
        },
        { title: '是否发送?', key: 'isSend', align: 'center', width: 100,
          component: {
            name: 'el-checkbox',
            trueLabel: 1,
            falseLabel: 0
          }
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          isSend: 0
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          isSend: 1
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          isSend: 0
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          isSend: 0
        }
      ]
    }
  },
  methods: {
    handleCellDataChange({ rowIndex, key, value, row }) {
      console.log(rowIndex)
      console.log(key)
      console.log(value)
      console.log(row)
    },
    keyupTest(row) {
      console.log(row)
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>表格内编辑（限制 input 输入数字）</h3>
<demo-block>
        <div><p>向<code>columns</code>的<code>component</code>对象传入<code>onlyNumber</code>属性来开启限制 input 输入数字，示例如下：</p>
</div>
        <template slot="source"><element-demo38 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '正整数',
          key: 'num1',
          component: {
            name: 'el-input',
            placeholder: '请输入正整数',
            size: 'small',
            onlyNumber: true
          }
        },
        {
          title: '大于等于0小于等于200',
          key: 'num2',
          component: {
            name: 'el-input',
            placeholder: '请输入大于等于0小于等于200的数',
            size: 'small',
            onlyNumber: {
              max: 200,
              min: 0
            }
          }
        },
        {
          title: '保留三位小数',
          key: 'num3',
          component: {
            name: 'el-input',
            placeholder: '请输入正数保留三位小数',
            size: 'small',
            onlyNumber: {
              toFixed: 3
            }
          }
        },
        {
          title: '数字随意输',
          key: 'num4',
          component: {
            name: 'el-input',
            placeholder: '不限制输入数字，例如 000013',
            size: 'small',
            onlyNumber: {
              type: 'zeroBefore'
            }
          }
        }
      ],
      data: [
        { date: '', name: '', address: '' },
        { date: '', name: '', address: '' },
        { date: '', name: '', address: '' },
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>表格自定义组件</h3>
<demo-block>
        <div><p>向<code>columns</code>的<code>component</code>对象的<code>name</code>传入自定义组件来进行渲染，如果是<a href="https://cn.vuejs.org/v2/guide/components-registration.html#%E5%85%A8%E5%B1%80%E6%B3%A8%E5%86%8C">全局注册</a>的自定义组件，只需传入组件名即可；如果是<a href="https://cn.vuejs.org/v2/guide/components-registration.html#%E5%B1%80%E9%83%A8%E6%B3%A8%E5%86%8C">局部注册</a>的组件，则需要传入<code>import</code>的那个组件对象。自定义组件的写法需要符合<a href="https://cn.vuejs.org/v2/guide/components-custom-events.html#%E8%87%AA%E5%AE%9A%E4%B9%89%E7%BB%84%E4%BB%B6%E7%9A%84-v-model">自定义组件使用v-model</a>的写法，可以在<code>component</code>中传入<code>props</code>字段，传入的字段可以在自定义组件中通过<code>props</code>接收，自定义组件还可以通过在<code>props</code>中定义<code>scope</code>字段来拿到当前行的所有数据。</p>
</div>
        <template slot="source"><element-demo39 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot; /&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date',
          width: '180'
        },
        {
          title: '姓名',
          key: 'name',
          width: '180'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: 'ApexLink组件，点击可跳转',
          key: 'check',
          component: {
            name: 'apex-link',
            props: {
              value: '我是通过props传过来的数据！',
              to: '/'
            }
          }
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          check: true
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          check: false
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          check: true
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          check: true
        }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>通过插槽形式自定义内容</h3>
<demo-block>
        <div><p>通过 slot 插槽渲染自定义内容，具体用法如下：</p>
</div>
        <template slot="source"><element-demo40 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-table :columns=&quot;columns&quot; :data=&quot;data&quot;&gt;
  &lt;template v-slot:linkSlot=&quot;{ scope }&quot;&gt;
    &lt;apex-link type=&quot;success&quot; to=&quot;/&quot; :params=&quot;{ name: 'wuhao', age: '18' }&quot;&gt;{{ scope.row.check }}&lt;/apex-link&gt;
  &lt;/template&gt;
&lt;/apex-table&gt;

&lt;script&gt;
export default {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date',
          width: '180'
        },
        {
          title: '姓名',
          key: 'name',
          width: '180'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: 'ApexLink组件，点击可跳转',
          key: 'check',
          slotName: 'linkSlot'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          check: '测试111'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          check: '测试222'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          check: '测试333'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          check: '测试444'
        }
      ]
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h3>apex-table Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>data</td>
<td>要显示的数据</td>
<td>Array</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>columns</td>
<td>表头数据</td>
<td>Array</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>options</td>
<td>表格配置数据</td>
<td>Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>loading</td>
<td>表格加载状态</td>
<td>Boolean</td>
<td>true/false</td>
<td>—</td>
</tr>
<tr>
<td>loading-options</td>
<td>表格加载配置数据</td>
<td>Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>index-row</td>
<td>索引</td>
<td>Object / Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>radio-row</td>
<td>单选</td>
<td>Object / Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>selection-row</td>
<td>多选</td>
<td>Object / Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>pagination</td>
<td>分页配置数据</td>
<td>Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>lt-one-page</td>
<td>是否开启当总条数小于一页时不显示分页</td>
<td>Boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>clientPagination</td>
<td>是否开启客户端分页（默认为服务端分页）</td>
<td>Boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>columns Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>表格列名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>key</td>
<td>data 中对应列的键名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>width</td>
<td>对应列的宽度</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>minWidth</td>
<td>对应列的最小宽度，与 width 的区别是 width 是固定的，minWidth 会把剩余宽度按比例分配给设置了 minWidth 的列</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>fixed</td>
<td>列是否固定在左侧或者右侧，true 表示固定在左侧</td>
<td>String / Boolean</td>
<td>true / left / right</td>
<td>—</td>
</tr>
<tr>
<td>renderHeader</td>
<td>列标题 Label 区域渲染使用的 Function</td>
<td>Function (h, { column, $index })</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>sortable</td>
<td>对应列是否可以排序，如果设置为 'custom'，则代表用户希望远程排序，需要监听 Table 的 sort-change 事件</td>
<td>Boolean / String</td>
<td>true, false, 'custom'</td>
<td>false</td>
</tr>
<tr>
<td>sortMethod</td>
<td>对数据进行排序的时候使用的方法，仅当 sortable 设置为 true 的时候有效，需返回一个数字，和 Array.sort 表现一致</td>
<td>Function (a, b)</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>sortBy</td>
<td>指定数据按照哪个属性进行排序，仅当 sortable 设置为 true 且没有设置 sort-method 的时候有效。如果 sort-by 为数组，则先按照第 1 个属性排序，如果第 1 个相等，再按照第 2 个排序，以此类推</td>
<td>String / Array / Function (row, index)</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>sortOrders</td>
<td>数据在排序时所使用排序策略的轮转顺序，仅当 sortable 为 true 时有效。需传入一个数组，随着用户点击表头，该列依次按照数组中元素的顺序进行排序</td>
<td>array</td>
<td>数组中的元素需为以下三者之一：ascending 表示升序，descending 表示降序，null 表示还原为原始顺序</td>
<td>['ascending', 'descending', null]</td>
</tr>
<tr>
<td>resizable</td>
<td>对应列是否可以通过拖动改变宽度（需要在 options 中设置 border 属性为 true</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>formatter</td>
<td>用来格式化内容</td>
<td>Function (row, column, cellValue, index)</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>showOverflowTooltip</td>
<td>当内容过长被隐藏时显示 tooltip</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>align</td>
<td>对齐方式</td>
<td>string</td>
<td>left / center / right</td>
<td>left</td>
</tr>
<tr>
<td>headerAlign</td>
<td>表头对齐方式，若不设置该项，则使用表格的对齐方式</td>
<td>string</td>
<td>left / center / right</td>
<td>—</td>
</tr>
<tr>
<td>className</td>
<td>列的 className</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>labelClassName</td>
<td>当前列标题的自定义类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>filters</td>
<td>数据过滤的选项，数组格式，数组中的元素需要有 text 和 value 属性。</td>
<td>Function ({ text, value })</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>filterPlacement</td>
<td>过滤弹出框的定位</td>
<td>string</td>
<td>top / top-start / top-end / bottom / bottom-start / bottom-end / left / left-start / left-end / right / right-start / right-end</td>
<td>bottom</td>
</tr>
<tr>
<td>filterMultiple</td>
<td>数据过滤的选项是否多选</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>filterMethod</td>
<td>数据过滤使用的方法，如果是多选的筛选项，对每一条数据会执行多次，任意一次返回 true 就会显示。</td>
<td>Function (value, row, column)</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>filteredValue</td>
<td>选中的数据过滤项，如果需要自定义表头过滤的渲染方式，可能会需要此属性。</td>
<td>Array</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>component.name</td>
<td>表格渲染的组件名</td>
<td>string</td>
<td>el-input / el-input-number / el-radio / el-checkbox / el-select / el-cascader / el-switch / el-slider / el-time-select / el-time-picker / el-date-picker / el-rate / el-color-picker / 自定义组件</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>options Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>height</td>
<td>表格的高度，默认为自动高度。如果 height 为 number 类型，单位 px；如果 height 为 String 类型，则这个高度会设置为表格的 style.height 的值，表格的高度会受控于外部样式。</td>
<td>String / Number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>maxHeight</td>
<td>表格的最大高度</td>
<td>String / Number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>stripe</td>
<td>是否为斑马纹模式</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>border</td>
<td>是否带有纵向边框</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>size</td>
<td>表格的尺寸</td>
<td>string</td>
<td>medium / small / mini</td>
<td>—</td>
</tr>
<tr>
<td>fit</td>
<td>列的宽度是否自撑开</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>showHeader</td>
<td>是否显示表头</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>highlightCurrentRow</td>
<td>是否要高亮当前行</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>currentRowKey</td>
<td>当前行的 key，只写属性</td>
<td>String / Number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>rowClassName</td>
<td>行的 className 的回调方法，也可以使用字符串为所有行设置一个固定的 className。</td>
<td>Function ({row, rowIndex}) / String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>rowStyle</td>
<td>行的 style 的回调方法，也可以使用一个固定的 Object 为所有行设置一样的 Style。</td>
<td>Function ({row, rowIndex}) / Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>cellClassName</td>
<td>单元格的 className 的回调方法，也可以使用字符串为所有单元格设置一个固定的 className。</td>
<td>Function ({row, column, rowIndex, columnIndex}) / String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>cellStyle</td>
<td>单元格的 style 的回调方法，也可以使用一个固定的 Object 为所有单元格设置一样的 Style。</td>
<td>Function ({row, column, rowIndex, columnIndex}) / Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>headerRowClassName</td>
<td>表头行的 className 的回调方法，也可以使用字符串为所有表头行设置一个固定的 className。</td>
<td>Function ({row, rowIndex}) / String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>headerRowStyle</td>
<td>表头行的 style 的回调方法，也可以使用一个固定的 Object 为所有表头行设置一样的 Style。</td>
<td>Function ({row, rowIndex}) / Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>headerCellClassName</td>
<td>表头单元格的 className 的回调方法，也可以使用字符串为所有表头单元格设置一个固定的 className。</td>
<td>Function ({row, column, rowIndex, columnIndex}) / String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>headerCellStyle</td>
<td>表头单元格的 style 的回调方法，也可以使用一个固定的 Object 为所有表头单元格设置一样的 Style。</td>
<td>Function ({row, column, rowIndex, columnIndex}) / Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>rowKey</td>
<td>行数据的 Key，用来优化表格的渲染；在使用 reserveSelection 功能的情况下，该属性是必填的。类型为 String 时，支持多层访问：user.info.id，但不支持 user.info[0].id，此种情况请使用 function。</td>
<td>Function (row) / String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>emptyText</td>
<td>空数据时显示的文本内容</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>defaultSort</td>
<td>默认的排序列的 prop 和顺序。它的prop属性指定默认的排序的列，order指定默认排序的顺序</td>
<td>Object</td>
<td>order: ascending / descending</td>
<td>如果只指定了 prop, 没有指定order, 则默认顺序是 ascending</td>
</tr>
<tr>
<td>tooltipEffect</td>
<td>tooltip effect 属性</td>
<td>string</td>
<td>dark / light</td>
<td>—</td>
</tr>
<tr>
<td>showSummary</td>
<td>是否在表尾显示合计行</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>sumText</td>
<td>合计行第一列的文本</td>
<td>string</td>
<td>—</td>
<td>合计</td>
</tr>
<tr>
<td>summaryMethod</td>
<td>自定义的合计计算方法</td>
<td>Function ({ columns, data })</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>spanMethod</td>
<td>合并行或列的计算方法</td>
<td>Function ({ row, column, rowIndex, columnIndex })</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>selectOnIndeterminate</td>
<td>在多选表格中，当仅有部分行被选中时，点击表头的多选框时的行为。若为 true，则选中所有行；若为 false，则取消选择所有行</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
</tbody>
</table>
<h3>loading-options Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>text</td>
<td>加载状态文案</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>spinner</td>
<td>加载状态图标类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>background</td>
<td>加载状态背景色值</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>index-row Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>indexRow 列名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>width</td>
<td>indexRow 宽度</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>minWidth</td>
<td>indexRow 最小宽度，与 width 的区别是 width 是固定的，minWidth 会把剩余宽度按比例分配给设置了 minWidth 的列</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>fixed</td>
<td>indexRow 是否固定在左侧或者右侧，true 表示固定在左侧</td>
<td>String / Boolean</td>
<td>true / left / right</td>
<td>—</td>
</tr>
<tr>
<td>renderHeader</td>
<td>indexRow 标题 Label 区域渲染使用的 Function</td>
<td>Function (h, { column, $index })</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>resizable</td>
<td>indexRow 是否可以通过拖动改变宽度（需要在 options 中设置 border 属性为 true</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>align</td>
<td>对齐方式</td>
<td>string</td>
<td>left / center / right</td>
<td>left</td>
</tr>
<tr>
<td>headerAlign</td>
<td>表头对齐方式，若不设置该项，则使用表格的对齐方式</td>
<td>string</td>
<td>left / center / right</td>
<td>—</td>
</tr>
<tr>
<td>className</td>
<td>indexRow 的 className</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>labelClassName</td>
<td>indexRow 标题的自定义类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>continuous</td>
<td>是否开启分页序号连续</td>
<td>boolean</td>
<td>true/false</td>
<td>false</td>
</tr>
<tr>
<td>index</td>
<td>不按顺序，自定义序号</td>
<td>function</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>selection-row Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>selectionRow 列名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>width</td>
<td>selectionRow 宽度</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>minWidth</td>
<td>selectionRow 最小宽度，与 width 的区别是 width 是固定的，minWidth 会把剩余宽度按比例分配给设置了 minWidth 的列</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>fixed</td>
<td>selectionRow 是否固定在左侧或者右侧，true 表示固定在左侧</td>
<td>String / Boolean</td>
<td>true / left / right</td>
<td>—</td>
</tr>
<tr>
<td>renderHeader</td>
<td>selectionRow 标题 Label 区域渲染使用的 Function</td>
<td>Function (h, { column, $index })</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>resizable</td>
<td>selectionRow 是否可以通过拖动改变宽度（需要在 options 中设置 border 属性为 true</td>
<td>Boolean</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>align</td>
<td>对齐方式</td>
<td>string</td>
<td>left / center / right</td>
<td>left</td>
</tr>
<tr>
<td>headerAlign</td>
<td>表头对齐方式，若不设置该项，则使用表格的对齐方式</td>
<td>string</td>
<td>left / center / right</td>
<td>—</td>
</tr>
<tr>
<td>className</td>
<td>selectionRow 的 className</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>labelClassName</td>
<td>selectionRow 标题的自定义类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
</tbody>
</table>
<h3>row-handle Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>columnHeader</td>
<td>操作列表头文字</td>
<td>string</td>
<td>—</td>
<td>操作</td>
</tr>
<tr>
<td>width</td>
<td>操作列宽度</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>minWidth</td>
<td>操作列最小宽度</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>fixed</td>
<td>操作列固定列</td>
<td>String / Boolean</td>
<td>true / left / right</td>
<td>—</td>
</tr>
<tr>
<td>align</td>
<td>操作列对齐方式</td>
<td>left / center / right</td>
<td>—</td>
<td>left</td>
</tr>
<tr>
<td>renderHeader</td>
<td>操作列 Label 区域渲染使用的 Function</td>
<td>Function (h, { column, $index })</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remove</td>
<td>删除模式</td>
<td>Object</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remove.text</td>
<td>删除按钮文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remove.confirm</td>
<td>是否弹出confirm框</td>
<td>Boolean</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remove.confirmTitle</td>
<td>删除confirm框的标题</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remove.confirmText</td>
<td>删除confirm框的文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remove.size</td>
<td>删除按钮尺寸</td>
<td>string</td>
<td>medium / small / mini</td>
<td>—</td>
</tr>
<tr>
<td>remove.type</td>
<td>删除按钮类型</td>
<td>string</td>
<td>primary / success / warning / danger / info / text</td>
<td>—</td>
</tr>
<tr>
<td>remove.icon</td>
<td>删除按钮图标类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>remove.show</td>
<td>控制是否显示删除按钮，类型为 Function 时，返回值只能为 true 或 false</td>
<td>Boolean / Function (index, row)</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>remove.disabled</td>
<td>控制是否禁用删除按钮，类型为 Function 时，返回值只能为 true 或 false</td>
<td>Boolean / Function (index, row)</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>custom</td>
<td>自定义按钮</td>
<td>array</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>custom.emit</td>
<td>自定义按钮监听的事件</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>custom.text</td>
<td>自定义按钮文字</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>custom.size</td>
<td>自定义按钮尺寸</td>
<td>string</td>
<td>medium / small / mini</td>
<td>—</td>
</tr>
<tr>
<td>custom.type</td>
<td>自定义按钮类型</td>
<td>string</td>
<td>primary / success / warning / danger / info / text</td>
<td>—</td>
</tr>
<tr>
<td>custom.icon</td>
<td>自定义按钮图标类名</td>
<td>string</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>custom.show</td>
<td>控制是否显示自定义按钮，类型为 Function 时，返回值只能为 true 或 false</td>
<td>Boolean / Function (index, row)</td>
<td>—</td>
<td>true</td>
</tr>
<tr>
<td>custom.disabled</td>
<td>控制是否禁用自定义按钮，类型为 Function 时，返回值只能为 true 或 false</td>
<td>Boolean / Function (index, row)</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>pagination Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>currentPage</td>
<td>表格当前页</td>
<td>Number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>pageSize</td>
<td>表格每页行数</td>
<td>Number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>total</td>
<td>总条数</td>
<td>Number</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>pageCount</td>
<td>页码按钮的数量，当总页数超过该值时会折叠</td>
<td>Number</td>
<td>大于等于 5 且小于等于 21 的奇数</td>
<td>7</td>
</tr>
<tr>
<td>small</td>
<td>是否使用小型分页样式</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>background</td>
<td>是否为分页按钮添加背景色</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>layout</td>
<td>组件布局，子组件名用逗号分隔</td>
<td>String</td>
<td>sizes, prev, pager, next, jumper, -&gt;, total, slot</td>
<td>'prev, pager, next, jumper, -&gt;, total'</td>
</tr>
<tr>
<td>pageSizes</td>
<td>每页显示个数选择器的选项设置</td>
<td>Number[]</td>
<td>—</td>
<td>[10, 20, 30, 40, 50, 100]</td>
</tr>
<tr>
<td>popperClass</td>
<td>每页显示个数选择器的下拉框类名</td>
<td>String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>prevText</td>
<td>替代图标显示的上一页文字</td>
<td>String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>nextText</td>
<td>替代图标显示的上一页文字</td>
<td>String</td>
<td>—</td>
<td>—</td>
</tr>
<tr>
<td>disabled</td>
<td>是否禁用</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>select</td>
<td>当用户手动勾选数据行的 Checkbox 时触发的事件</td>
<td>selection, row</td>
</tr>
<tr>
<td>select-all</td>
<td>当用户手动勾选全选 Checkbox 时触发的事件</td>
<td>selection</td>
</tr>
<tr>
<td>selection-change</td>
<td>当选择项发生变化时会触发该事件</td>
<td>selection</td>
</tr>
<tr>
<td>current-change</td>
<td>当表格的当前行发生变化的时候会触发该事件，如果要高亮当前行，请打开 options 中的 highlight-current-row 属性</td>
<td>currentRow, oldCurrentRow</td>
</tr>
<tr>
<td>cell-mouse-enter</td>
<td>当单元格 hover 进入时会触发该事件</td>
<td>row, column, cell, event</td>
</tr>
<tr>
<td>cell-mouse-leave</td>
<td>当单元格 hover 退出时会触发该事件</td>
<td>row, column, cell, event</td>
</tr>
<tr>
<td>cell-click</td>
<td>当某个单元格被点击时会触发该事件</td>
<td>row, column, cell, event</td>
</tr>
<tr>
<td>cell-dblclick</td>
<td>当某个单元格被双击击时会触发该事件</td>
<td>row, column, cell, event</td>
</tr>
<tr>
<td>row-click</td>
<td>当某一行被点击时会触发该事件</td>
<td>row, event, column</td>
</tr>
<tr>
<td>row-contextmenu</td>
<td>当某一行被鼠标右键点击时会触发该事件</td>
<td>row, event</td>
</tr>
<tr>
<td>row-dblclick</td>
<td>当某一行被双击时会触发该事件</td>
<td>row, event</td>
</tr>
<tr>
<td>header-click</td>
<td>当某一列的表头被点击时会触发该事件</td>
<td>column, event</td>
</tr>
<tr>
<td>header-contextmenu</td>
<td>当某一列的表头被鼠标右键点击时触发该事件</td>
<td>column, event</td>
</tr>
<tr>
<td>sort-change</td>
<td>当表格的排序条件发生变化的时候会触发该事件</td>
<td>{ column, prop, order }</td>
</tr>
<tr>
<td>filter-change</td>
<td>当表格的筛选条件发生变化的时候会触发该事件，参数的值是一个对象，对象的 key 是 column 的 columnKey，对应的 value 为用户选择的筛选条件的数组。</td>
<td>filters</td>
</tr>
<tr>
<td>row-add</td>
<td>当表格新增数据的时候会触发该事件</td>
<td>row, done</td>
</tr>
<tr>
<td>row-edit</td>
<td>当表格修改数据的时候会触发该事件</td>
<td>index, row, done</td>
</tr>
<tr>
<td>row-remove</td>
<td>当表格删除数据的时候会触发该事件</td>
<td>index, row, done</td>
</tr>
<tr>
<td>pagination-size-change</td>
<td>当分页 pageSize 改变时会触发</td>
<td>pageSize</td>
</tr>
<tr>
<td>pagination-current-change</td>
<td>当分页 currentPage 改变时会触发</td>
<td>currentPage</td>
</tr>
<tr>
<td>pagination-prev-click</td>
<td>当分页上一页按钮被用户点击改变当前页后触发</td>
<td>currentPage</td>
</tr>
<tr>
<td>pagination-next-click</td>
<td>当分页下一页按钮被用户点击改变当前页后触发</td>
<td>currentPage</td>
</tr>
<tr>
<td>cell-data-change</td>
<td>表格内编辑时单元格数据改变触发</td>
<td>rowIndex,key,value,row</td>
</tr>
<tr>
<td>form-data-change</td>
<td>表单数据改变触发</td>
<td>key,value</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('el-button',{on:{"click":function($event){return _vm.$refs.refAdaptiveTable.setAdaptive()}}},[_vm._v("手动调用setAdaptive")]),_vm._v(" "),_c('el-alert',{staticStyle:{"margin-left":"20px"},attrs:{"title":"试试把滚动条往下滚动一点，让表格移位，然后再点击按钮（手动调用setAdaptive）","type":"info","show-icon":"","closable":false}})],1),_vm._v(" "),_c('apex-table',{ref:"refAdaptiveTable",attrs:{"columns":_vm.columns,"data":_vm.data,"adaptive":{ offsetBottom: 70 }}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: true
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data},on:{"row-dblclick":_vm.testClick}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      loaidng: true,
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  },
  methods: {
    testClick() {
      console.log(12111)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{on:{"click":function($event){_vm.loading = !_vm.loading}}},[_vm._v("点我切换加载状态")]),_vm._v(" "),_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: true
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        border: false
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"toolbar":{ storage: 'toolbar_resizable_storage', columnsSetup: true, resizable: true }}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading,"toolbar":{ storage: 'toolbar-storage', storageNeedPrefix: false },"header-operations":_vm.headerOperations,"options":_vm.options},on:{"refresh":_vm.init,"add":_vm.add,"edit":_vm.edit},scopedSlots:_vm._u([{key:"slotButton",fn:function(){return [_c('el-dropdown',{staticStyle:{"margin-right":"10px"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("\n        更多菜单"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_vm._v("黄金糕")]),_vm._v(" "),_c('el-dropdown-item',[_vm._v("狮子头")]),_vm._v(" "),_c('el-dropdown-item',[_vm._v("螺蛳粉")]),_vm._v(" "),_c('el-dropdown-item',[_vm._v("双皮奶")]),_vm._v(" "),_c('el-dropdown-item',[_vm._v("蚵仔煎")])],1)],1)]},proxy:true},{key:"headerOperationSlot",fn:function(){return [_c('el-checkbox',{model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("插槽进来的按钮")])]},proxy:true}])})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      checked: false,
      renderHeaderValue: '',
      columns: [
        { title: '日期', key: 'date', minWidth: 200, disabled: true },
        { title: '测试列1', key: 'test1', minWidth: 200 },
        { title: '测试列2', key: 'test2', minWidth: 200 },
        { title: '测试列3', key: 'test3', minWidth: 200 },
        { title: '默认隐藏列', key: 'hidden', minWidth: 200, show: false },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      headerOperations: [
        { text: '新增', type: 'primary', icon: 'el-icon-plus', emit: 'add' },
        { slotName: 'slotButton' },
        { text: '修改', type: 'danger', icon: 'el-icon-edit', emit: 'edit' }
      ],
      options: {
        border: true
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() => {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    add() {
      this.$message.success('点击了新增按钮')
    },
    edit() {
      this.$message.success('点击了修改按钮')
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo6": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading,"toolbar":{ storage: 'exportExcel-storage', exportExcel: true }},on:{"refresh":_vm.init,"export-excel":_vm.exportExcel}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', minWidth: 200 },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() => {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    exportExcel(list) {
      console.log(list)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo7": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading,"toolbar":{ storage: 'toolbar-storage-sort', disabledFixed: true, disabledSort: true },"header-operations":_vm.headerOperations,"options":_vm.options},on:{"refresh":_vm.init,"add":_vm.add,"edit":_vm.edit}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      renderHeaderValue: '',
      columns: [
        { title: '日期', key: 'date', width: 200, disabled: true },
        { title: '自定义表头', key: 'renderHeader', width: 200,
          renderHeader: (h, { column, $index }) => {
            const that = this
            return h('div', { class: { 'rendered-header': true }}, [
              h('div', column.label),
              h('el-input', {
                props: {
                  value: that.renderHeaderValue,
                  clearable: true
                },
                attrs: { placeholder: 'filter column' },
                 on: {
                  input(val) {
                    that.renderHeaderValue = val
                  }
                }
              })
            ])
          }
        },
        { title: '测试列1', key: 'test1', width: 200 },
        { title: '测试列2', key: 'test2', width: 200 },
        { title: '测试列3', key: 'test3', width: 200 },
        { title: '默认隐藏列', key: 'hidden', width: 200, show: false },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address', width: 400 }
      ],
      data: [
        { date: '2020-04-12', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', test1: '测试111', test2: '测试222', test3: '测试333', hidden: '默认隐藏的列', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      headerOperations: [
        { text: '新增', type: 'primary', icon: 'el-icon-plus', emit: 'add' },
        { text: '修改', type: 'danger', icon: 'el-icon-edit', emit: 'edit' }
      ],
      options: {
        border: true
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() => {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    add() {
      this.$message.success('点击了新增按钮')
    },
    edit() {
      this.$message.success('点击了修改按钮')
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo8": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{ref:"apexTable",attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading,"toolbar":{ storage: 'toolbar-mark', mark: 'id' },"header-operations":_vm.headerOperations,"selection-row":{ isRowClick: true, isBgc: true }},on:{"refresh":_vm.init,"complete":_vm.complete,"reset":_vm.reset}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      renderHeaderValue: '',
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { id: 1, date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { id: 2, date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { id: 3, date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { id: 4, date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 5, date: '2020-04-14', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 6, date: '2020-04-15', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 7, date: '2020-04-16', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 8, date: '2020-04-17', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { id: 9, date: '2020-04-18', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      headerOperations: [
        { text: '重置第二行mark状态', type: 'primary', emit: 'complete' },
        { text: '清空所有行mark状态', type: 'danger', emit: 'reset' }
      ]
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() => {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    complete() {
      this.$refs.apexTable.setMarkRow(this.data[1])
    },
    reset() {
      this.$refs.apexTable.clearAllMarkRow()
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo9": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{ref:"apexTable",attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading,"toolbar":_vm.toolbarOptions},on:{"refresh":_vm.init,"combSortChange":_vm.combSortChange}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', minWidth: 200, disabled: true, combSort: true },
        { title: '姓名', key: 'name', minWidth: 200,
          combSort: { title: '自定义title', key: 'testKey', orderBy: 'desc' }
        },
        { title: '地址', key: 'address', minWidth: 400, combSort: { orderBy: 'asc' } }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      toolbarOptions: {
        storage: 'comSortTable'
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() => {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    combSortChange(sortList, changeType) {
      console.log(sortList)
      console.log(changeType)
      this.$message('按需请求接口排序')
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo10": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.setCombSortList}},[_vm._v("动态设置组合排序字段")]),_vm._v(" "),_c('apex-table',{ref:"apexTable",attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading,"toolbar":_vm.toolbarOptions},on:{"refresh":_vm.init,"combSortChange":_vm.combSortChange}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', minWidth: 200, disabled: true },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      toolbarOptions: {
        storage: 'comSortTable',
        combSortList: [
          { title: '地址', key: 'address', orderBy: 'desc' },
          { title: '日期', key: 'date', orderBy: 'asc' },
          { title: '姓名', key: 'name', orderBy: '' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() => {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000)
    },
    combSortChange(sortList, changeType) {
      console.log(sortList)
      console.log(changeType)
      this.$message('按需请求接口排序')
    },
    setCombSortList() {
      this.loading = true
      setTimeout(() => {
        const list = [
          { title: '动态字段111', key: 'sortField1', orderBy: 'asc' },
          { title: '动态字段222', key: 'sortField2', orderBy: '' },
          { title: '动态字段333', key: 'sortField3', orderBy: 'desc' },
        ]
        this.$refs.apexTable.setCombSortList(list)
        this.$message.success('动态设置组合排序字段成功')
        this.loading = false
      }, 2000)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo11": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading,"toolbar":_vm.toolbarOptions,"options":_vm.options},on:{"refresh":_vm.init,"customFn1":_vm.customFn1,"customFn2":_vm.customFn2},scopedSlots:_vm._u([{key:"toolbarSlot",fn:function(){return [_c('el-checkbox',{staticStyle:{"margin-right":"10px"},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("插槽的组件")])]},proxy:true}])})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      checked: false,
      columns: [
        { title: '日期', key: 'date', minWidth: 200 },
        { title: '姓名', key: 'name', minWidth: 200 },
        { title: '地址', key: 'address', minWidth: 400 }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      loading: false,
      toolbarOptions: {
        columnsSetup: false,
        storage: 'customBtns-table',
        customBtns: [
          { title: '自定义toolbar按钮1', icon: 'el-icon-bottom', emit: 'customFn1' },
          { title: '自定义toolbar按钮2', icon: 'el-icon-share', type: 'primary', emit: 'customFn2' }
        ],
        advancedSearch: true,
        toolbarSlotPosition: 'left'
      },
      options: {
        border: true
      }
    }
  },
  methods: {
    init() {
      this.loading = true
      setTimeout(() => {
        this.$message.success('刷新成功')
        this.loading = false
      }, 2000);
    },
    customFn1() {
      this.$message.success('点击了 自定义toolbar按钮1')
      if (this.toolbarOptions.customBtns[0].icon === 'el-icon-bottom') {
        this.toolbarOptions.customBtns[0].icon = 'el-icon-top'
        this.toolbarOptions.customBtns[0].type = 'success'
      } else {
        this.toolbarOptions.customBtns[0].icon = 'el-icon-bottom'
        this.toolbarOptions.customBtns[0].type = ''
      }
    },
    customFn2() {
      this.$message.success('点击了 自定义toolbar按钮2')
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo12": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{ref:"apexTable",attrs:{"header-bgc":"","loading":_vm.tableLoading,"columns":_vm.columns,"data":_vm.data,"header-operations":_vm.headerOperations,"toolbar":_vm.toolbarOptions},on:{"resetSearchValue":_vm.resetSearchValue,"asyncGetData":_vm.asyncGetData},scopedSlots:_vm._u([{key:"countSlot",fn:function(ref){
var scope = ref.scope;
return [_c('span',[_vm._v(_vm._s(scope.title)+" - slot自定义标题")]),_vm._v(" "),_c('div',{staticClass:"apex-table-header-slot"},[_c('el-input',{attrs:{"placeholder":"插槽示例"},model:{value:(scope.filterColumnObj[scope.filterColumn.keys[0]]),callback:function ($$v) {_vm.$set(scope.filterColumnObj, scope.filterColumn.keys[0], $$v)},expression:"scope.filterColumnObj[scope.filterColumn.keys[0]]"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"插槽示例"},model:{value:(scope.filterColumnObj[scope.filterColumn.keys[1]]),callback:function ($$v) {_vm.$set(scope.filterColumnObj, scope.filterColumn.keys[1], $$v)},expression:"scope.filterColumnObj[scope.filterColumn.keys[1]]"}})],1)]}}])})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      tableLoading: false,
      asyncList: [],
      headerOperations: [
        { text: '重置过滤框值', type: 'primary', emit: 'resetSearchValue' },
        { text: '异步获取姓名下拉', type: 'primary', emit: 'asyncGetData' }
      ],
      toolbarOptions: {
        storage: 'toolbar-reset-table',
        reset: true
      },
      data: [
        { date: '2022-06-12', count: 111, type: '类型1', name: '詹姆斯', name2: 1, address: '武汉市江汉区泛海国际SOHO城 1518 弄' },
        { date: '2022-06-14', count: 222, type: '类型2', name: '安东尼', name2: 0, address: '武汉市江汉区泛海国际SOHO城 1517 弄' },
        { date: '2022-06-11', count: 123, type: '类型3', name: '奥尼尔', name2: true, address: '武汉市江汉区泛海国际SOHO城 1519 弄' },
        { date: '2022-06-13', count: 356, type: '类型4', name: '杜兰特', name2: false, address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      columns: [
        { title: '日期', key: 'date', align: 'center', width: 250,
          filterColumn: {
            name: 'el-date-picker',
            type: 'daterange',
            // value: ['2022-06-03', '2022-06-15'], // 默认值
            value: () => {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            },
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '开始日期',
            'end-placeholder': '结束日期',
            keys: ['datetime'] // key别名，传给后台用的 不填默认为列的key
          }
        },
        { title: '起止日期框分开', key: 'date2', align: 'center', width: 300,
          filterColumn: {
            name: 'begin-end-date',
            keys: ['beginDate', 'endDate'],
            value: ['2022-06-03', '2022-06-15'], // 默认值
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            isRemote: true
          }
        },
        { title: 'apex-select下拉组件', key: 'type', align: 'center', width: 160,
          filterColumn: {
            name: 'apex-select',
            remote: true,
            localFilter: { max: 10 },
            options: [
              { label: '标题1', value: 1 },
              { label: '标题2', value: 2 },
              { label: '标题3', value: 3 },
              { label: '标题4', value: 4 },
              { label: '标题5', value: 5 },
              { label: '标题6', value: 6 },
              { label: '标题7', value: 7 },
              { label: '标题8', value: 8 },
              { label: '标题9', value: 9 },
              { label: '标题10', value: 10 },
              { label: '标题11', value: 11 },
              { label: '标题12', value: 12 },
              { label: '标题13', value: 13 },
              { label: '标题14', value: 14 },
              { label: '标题15', value: 15 },
              { label: '标题16', value: 16 },
              { label: '标题17', value: 17 },
              { label: '标题18', value: 18 },
              { label: '标题19', value: 19 },
              { label: '标题20', value: 20 },
              { label: '标题21', value: 21 },
              { label: '标题22', value: 22 },
              { label: '标题23', value: 23 },
              { label: '标题24', value: 24 },
              { label: '标题25', value: 25 },
            ]
          }
        },
        { title: '数量', key: 'count', align: 'center', width: 170,
          filterColumn: {
            slotName: 'countSlot',
            keys: ['count1', 'count2'],
            showTitle: false
          }
        },
        { title: '姓名', key: 'name', align: 'center', width: 150,
          filterColumn: {
            name: 'el-select',
            filterable: true,
            multiple: true,
            options: () => this.asyncList
          }
        },
        { title: '下拉类型', key: 'name2', align: 'center', width: 150,
          filterColumn: {
            name: 'el-select',
            options: [
              { label: '1', value: 1 },
              { label: '0', value: 0 },
              { label: 'true', value: true },
              { label: 'false', value: false },
            ]
          }
        },
        { title: '地址', key: 'address', align: 'center', width: 150,
          filterColumn: {
            name: 'el-input',
            customMethod: (key, val) => {
              console.log(key, val)
            }
          }
        }
      ]
    }
  },
  methods: {
    resetSearchValue() {
      this.$refs.apexTable.clearFilterColumnValue()
      this.$refs.apexTable.filterColumn(null, '', '')
    },
    asyncGetData() {
      this.tableLoading = true
      setTimeout(() => {
        this.$message.success('请求成功')
        this.asyncList = [
          { label: '詹姆斯', value: '詹姆斯' },
          { label: '安东尼', value: '安东尼' },
          { label: '奥尼尔', value: '奥尼尔' },
          { label: '杜兰特', value: '杜兰特' }
        ]
        this.tableLoading = false
      }, 1500)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo13": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{ref:"apexTable",attrs:{"header-bgc":"","loading":_vm.tableLoading,"columns":_vm.columns,"data":_vm.data,"header-operations":_vm.headerOperations,"toolbar":_vm.toolbarOptions},on:{"clearQueryAll":_vm.clearQueryAll,"advanced-search-expand-change":_vm.advancedSearchExpandChange,"advanced-search":_vm.testCallback,"advanced-search-reset":_vm.testCallback,"advanced-search-delete-template":_vm.testCallback,"advanced-search-save-template":_vm.testCallback,"advanced-search-set-as-default-template":_vm.testCallback,"advanced-search-click-template":_vm.handleClickTemplate,"advanced-search-field-change":_vm.fieldChange},scopedSlots:_vm._u([{key:"countNumslot",fn:function(ref){
var scope = ref.scope;
return [_c('span',[_vm._v(_vm._s(scope.title)+" - slot自定义标题")]),_vm._v(" "),_c('div',{staticClass:"apex-table-header-slot"},[_c('el-input',{attrs:{"placeholder":"插槽示例"},model:{value:(scope.filterColumnObj[scope.filterColumn.keys[0]]),callback:function ($$v) {_vm.$set(scope.filterColumnObj, scope.filterColumn.keys[0], $$v)},expression:"scope.filterColumnObj[scope.filterColumn.keys[0]]"}}),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"插槽示例"},model:{value:(scope.filterColumnObj[scope.filterColumn.keys[1]]),callback:function ($$v) {_vm.$set(scope.filterColumnObj, scope.filterColumn.keys[1], $$v)},expression:"scope.filterColumnObj[scope.filterColumn.keys[1]]"}})],1)]}}])})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      tableLoading: false,
      headerOperations: [
        { text: '清空所有条件(包括高级查询的)', type: 'primary', emit: 'clearQueryAll' }
      ],
      toolbarOptions: {
        storage: 'toolbar-reset-table',
        reset: true,
        advancedSearch: true
      },
      data: [
        { date: '2022-06-12', count: 111, name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' },
        { date: '2022-06-14', count: 222, name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' },
        { date: '2022-06-11', count: 123, name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' },
        { date: '2022-06-13', count: 356, name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      columns: [
        { title: '日期', key: 'date', align: 'center', width: 250,
          filterColumn: {
            name: 'el-date-picker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            'start-placeholder': '开始日期',
            'end-placeholder': '结束日期',
            keys: ['datetime'] // key别名，传给后台用的 不填默认为列的key
          }
        },
        { title: '数量', key: 'count', align: 'center',
          filterColumn: {
            slotName: 'countNumslot',
            keys: ['count1', 'count2'],
            showTitle: false
          }
        },
        { title: '姓名', key: 'name', align: 'center', width: 120,
          filterColumn: {
            name: 'el-select',
            filterable: true,
            multiple: true,
            options: [
              { label: '詹姆斯', value: '詹姆斯' },
              { label: '安东尼', value: '安东尼' },
              { label: '奥尼尔', value: '奥尼尔' },
              { label: '杜兰特', value: '杜兰特' }
            ]
          }
        },
        { title: '地址', key: 'address', align: 'center',
          filterColumn: {
            name: 'el-input',
            customMethod: (key, val) => {
              console.log(key, val)
            }
          }
        }
      ]
    }
  },
  methods: {
    clearQueryAll() {
      this.$refs.apexTable.clearFilterColumnValue()
      this.$refs.apexTable.filterColumn(null, '', '')
      this.$refs.apexTable.advancedSearchClearAll()
    },
    advancedSearchExpandChange({ expanded, loading }) {
      if (loading) {
        // 这里可以写调接口等逻辑
        setTimeout(() => {
          this.$message.success('请求成功')
          const res1 = [
            { key: 'key_1', text: '输入框', type: '0' },
            { key: 'key_2', text: '日期框', type: '1' },
            { key: 'key_3', text: '下拉框', type: '2', searchField: 'CR' },
            { key: 'key_4', text: '下拉框（多选）', type: '3', searchField: 'PORT' },
          ]
          const res2 = [
            { name: 'Amazon Group', id: 1, isDefault: 0 },
            { name: 'Amazon Group2222', id: 2, isDefault: 0 },
            { name: 'Amazon Group3333', id: 3, isDefault: 1 },
            { name: 'Amazon Group-test-2022-07-19 Group-test-2022-07-19', id: 4, isDefault: 0 },
            { name: 'Amazon Group', id: 5, isDefault: 0 },
            { name: 'Amazon Group', id: 6, isDefault: 0 },
            { name: '123', id: 7, isDefault: 0 },
            { name: '345', id: 8, isDefault: 0 },
            { name: '456', id: 9, isDefault: 0 }
          ]
          this.$refs.apexTable.advancedSearchSetFieldsList(res1)
          this.$refs.apexTable.advancedSearchSetTemplateList(res2, true) // 展开的时候需要传true选中默认模板
          this.$refs.apexTable.advancedSearchSetLoading(false)
        }, 1000)
      }
    },
    // 模拟示例  方法可分开
    testCallback(data) {
      console.log(data)
    },
    // 请求下拉的接口
    fieldChange(row) {
      console.log(row)
      this.$refs.apexTable.advancedSearchSetLoading(true)
      setTimeout(() => {
        this.$message.success('请求成功')
        this.$refs.apexTable.advancedSearchSetLoading(false)
        const res = [
          { label: '标题1', value: 1 },
          { label: '标题2', value: 2 },
          { label: '标题3', value: 3 },
          { label: '标题4', value: 4 },
          { label: '标题5', value: 5 },
          { label: '标题6', value: 6 },
          { label: '标题7', value: 7 },
          { label: '标题8', value: 8 },
          { label: '标题9', value: 9 },
          { label: '标题10', value: 10 },
          { label: '标题11', value: 11 },
          { label: '标题12', value: 12 },
          { label: '标题13', value: 13 },
          { label: '标题14', value: 14 },
          { label: '标题15', value: 15 },
          { label: '标题16', value: 16 },
          { label: '标题17', value: 17 },
          { label: '标题18', value: 18 },
          { label: '标题19', value: 19 },
          { label: '标题20', value: 20 },
          { label: '标题21', value: 21 },
          { label: '标题22', value: 22 },
          { label: '标题23', value: 23 },
          { label: '标题24', value: 24 },
          { label: '标题25', value: 25 },
        ]
        this.$refs.apexTable.advancedSearchSetSelectList(row.searchField, res)
      }, 1000)
    },
    // 点击查询template搜索条件
    handleClickTemplate({ id }) {
      this.$refs.apexTable.advancedSearchSetLoading(true)
      const res = [
          {
              "andOr": "and",
              "innerList": [
                  {
                      "andOr": "and",
                      "field": "key_1",
                      "operator": "=",
                      "value": "New"
                  },
                  {
                      "andOr": "and",
                      "field": "key_4",
                      "operator": "=",
                      "value": [2, 4]
                  },
                  {
                      "andOr": "and",
                      "field": "key_3",
                      "operator": "=",
                      "value": 8
                  }
              ]
          }
      ]
      setTimeout(() => {
        this.$message.success('请求成功')
        this.$refs.apexTable.advancedSearchSetQueryList(res)
        this.$refs.apexTable.advancedSearchSetLoading(false)
      }, 1000)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo14": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{ref:"refCustomerTable",attrs:{"header-bgc":"","loading":_vm.tableLoading,"columns":_vm.columns,"data":_vm.tableData,"toolbar":_vm.toolbarOptions},on:{"advanced-search-expand-change":_vm.advancedSearchExpandChange,"advanced-search":_vm.handleAdvancedSearch,"advanced-search-reset":_vm.handleAdvancedSearchReset,"advanced-search-field-change":_vm.fieldChange,"advanced-search-delete-template":_vm.handleDeleteTemplate,"advanced-search-save-template":_vm.handleSaveTemplate,"advanced-search-set-as-default-template":_vm.handleSetAsDefaultTemplate,"advanced-search-click-template":_vm.handleClickTemplate}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      tableLoading: false,
      toolbarOptions: {
        storage: 'toolbar-customer-select-table',
        reset: true,
        advancedSearch: true
      },
      columns: [
        { title: 'Order ID', key: 'orderId', width: 150, align: 'center' },
        { title: 'Customer Code', key: 'customerCode', width: 200, align: 'center' },
        { title: 'Customer Name', key: 'customerName', width: 200, align: 'center' },
        { title: 'Product', key: 'product', width: 200, align: 'center' },
        { title: 'Amount', key: 'amount', width: 120, align: 'center' },
        { title: 'Status', key: 'status', width: 120, align: 'center' },
        { title: 'Order Date', key: 'orderDate', align: 'center' }
      ],
      tableData: [
        { orderId: 'ORD001', customerCode: 'AMAZON-US-001', customerName: 'Amazon US', product: 'Laptop', amount: '$1200', status: 'Completed', orderDate: '2024-01-15' },
        { orderId: 'ORD002', customerCode: 'WALMART-US-001', customerName: 'Walmart US', product: 'Phone', amount: '$800', status: 'Pending', orderDate: '2024-01-16' },
        { orderId: 'ORD003', customerCode: 'AMAZON-UK-002', customerName: 'Amazon UK', product: 'Tablet', amount: '$500', status: 'Completed', orderDate: '2024-01-17' },
        { orderId: 'ORD004', customerCode: 'EBAY-US-001', customerName: 'eBay US', product: 'Monitor', amount: '$300', status: 'Shipped', orderDate: '2024-01-18' },
        { orderId: 'ORD005', customerCode: 'SHOPIFY-CA-001', customerName: 'Shopify CA', product: 'Keyboard', amount: '$150', status: 'Completed', orderDate: '2024-01-19' },
        { orderId: 'ORD006', customerCode: 'AMAZON-DE-003', customerName: 'Amazon DE', product: 'Mouse', amount: '$50', status: 'Pending', orderDate: '2024-01-20' }
      ]
    }
  },
  methods: {
    // 高级搜索展开/折叠时触发
    advancedSearchExpandChange({ expanded, loading }) {
      if (loading) {
        // 模拟请求字段列表和模板列表
        setTimeout(() => {
          this.$message.success('数据加载成功')
          
          // 设置高级搜索字段列表
          const fieldsList = [
            { key: 'orderId', text: 'Order ID', type: '0' }, // 文本输入
            { key: 'customerSingle', text: 'Customer (Single)', type: '2', searchField: 'CR' }, // 单选客户 - CustomerSelect
            { key: 'customerMultiple', text: 'Customer (Multiple)', type: '3', searchField: 'CR' }, // 多选客户 - CustomerSelect
            { key: 'product', text: 'Product', type: '0' }, // 文本输入
            { key: 'status', text: 'Status', type: '2', searchField: 'STATUS' }, // 普通单选下拉
            { key: 'orderDate', text: 'Order Date', type: '1' } // 日期选择
          ]
          
          // 设置模板列表（可选）
          const templateList = [
            { name: 'Amazon Orders', id: 1, isDefault: 1 },
            { name: 'Pending Orders', id: 2, isDefault: 0 },
            { name: 'High Value Orders', id: 3, isDefault: 0 }
          ]
          
          this.$refs.refCustomerTable.advancedSearchSetFieldsList(fieldsList)
          this.$refs.refCustomerTable.advancedSearchSetTemplateList(templateList, true)
          this.$refs.refCustomerTable.advancedSearchSetLoading(false)
        }, 1000)
      }
    },
    
    // 字段改变时触发（用于请求下拉选项数据）
    fieldChange(row) {
      console.log('Field changed:', row)
      this.$refs.refCustomerTable.advancedSearchSetLoading(true)
      
      setTimeout(() => {
        this.$message.success('选项数据加载成功')
        
        // 根据不同的 searchField 返回不同的数据
        if (row.searchField === 'CR') {
          // Customer 数据 - 注意格式必须包含 label, value, customerId, groupId
          // 使用循环生成2000条模拟数据，测试最多显示50条的效果
          const platforms = ['AMAZON', 'WALMART', 'EBAY', 'SHOPIFY', 'TARGET', 'BESTBUY', 'ALIEXPRESS', 'RAKUTEN', 'LAZADA', 'SHOPEE']
          const countries = ['US', 'UK', 'DE', 'FR', 'JP', 'CA', 'AU', 'IT', 'ES', 'IN', 'SG', 'MY', 'TH', 'PH', 'VN', 'ID', 'TW', 'BR', 'MX', 'AR']
          const customerData = []
          
          for (let i = 1; i <= 2000; i++) {
            const platform = platforms[i % platforms.length]
            const country = countries[i % countries.length]
            const num = String(i).padStart(3, '0')
            customerData.push({
              label: `${platform}-${country}-${num}`,
              value: `${platform}-${country}-${num}`,
              customerId: `CUS${num}`,
              groupId: `GRP${String(Math.floor(i / 10) + 1).padStart(3, '0')}`
            })
          }
          
          this.$refs.refCustomerTable.advancedSearchSetSelectList(row.searchField, customerData)
        } else if (row.searchField === 'STATUS') {
          // Status 普通下拉数据
          const statusData = [
            { label: 'Pending', value: 'Pending' },
            { label: 'Completed', value: 'Completed' },
            { label: 'Shipped', value: 'Shipped' },
            { label: 'Cancelled', value: 'Cancelled' }
          ]
          this.$refs.refCustomerTable.advancedSearchSetSelectList(row.searchField, statusData)
        }
        
        this.$refs.refCustomerTable.advancedSearchSetLoading(false)
      }, 500)
    },
    
    // 点击搜索按钮
    handleAdvancedSearch(queryList) {
      console.log('Advanced search:', queryList)
      this.$message.success('执行高级搜索')
      // 这里可以根据 queryList 调用接口查询数据
    },
    
    // 点击重置按钮
    handleAdvancedSearchReset(queryList) {
      console.log('Reset search:', queryList)
      this.$message.info('重置搜索条件')
    },
    
    // 删除模板
    handleDeleteTemplate(template) {
      console.log('Delete template:', template)
      this.$message.success('模板删除成功')
    },
    
    // 保存模板
    handleSaveTemplate(data) {
      console.log('Save template:', data)
      this.$message.success('模板保存成功')
    },
    
    // 设置为默认模板
    handleSetAsDefaultTemplate(template) {
      console.log('Set as default:', template)
      this.$message.success('设置默认模板成功')
    },
    
    // 点击模板
    handleClickTemplate(template) {
      console.log('Click template:', template)
      this.$refs.refCustomerTable.advancedSearchSetLoading(true)
      
      // 模拟加载模板对应的查询条件
      setTimeout(() => {
        const queryList = [
          {
            andOr: 'and',
            innerList: [
              { andOr: 'and', field: 'customerSingle', operator: '=', value: 'AMAZON-US-001' },
              { andOr: 'and', field: 'status', operator: '=', value: 'Completed' }
            ]
          }
        ]
        this.$refs.refCustomerTable.advancedSearchSetQueryList(queryList)
        this.$refs.refCustomerTable.advancedSearchSetLoading(false)
      }, 500)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo15": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"toolbar":{ refresh: false },"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200, sortable: true },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' },
        { title: '爱好', key: 'liked' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄', liked: '篮球' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄', liked: '足球' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄', liked: '羽毛球' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄', liked: '游泳' }
      ],
      options: {
        defaultSort: {prop: 'date', order: 'descending'}
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo16": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 120 },
        { title: '姓名', key: 'name', width: 120 },
        {
          title: '性别',
          key: 'gender',
          width: 120,
          formatter: (row, column, cellValue, index) => {
            return cellValue === 1 ? '男' : cellValue === 2 ? '女' : '未知'
          }
        },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', gender: 1, name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', gender: 2, name: '蕾欧娜', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', gender: 1, name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', gender: null, name: '大司马', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', gender: 2, name: '刘亦菲', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo17": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"index-row":_vm.indexRow,"options":_vm.options,"pagination":_vm.pagination,"client-pagination":""}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      indexRow: {
        title: '序号',
        continuous: true
      },
      options: {
        height: '300px'
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo18": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        stripe: true
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo19": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        rowStyle ({row, rowIndex}) {
          if (rowIndex === 1) {
            return { background: 'oldlace' }
          } else if (rowIndex === 3) {
            return { background: '#f0f9eb' }
          }
        }
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo20": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        height: '250'
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo21": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 130, fixed: true },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address', width: 300 },
        { title: '爱好', key: 'liked', width: 200 },
        { title: '省份', key: 'province', width: 200 },
        { title: '市区', key: 'city', width: 200 },
        { title: '区域', key: 'county', width: 200, fixed: 'right' },
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄', liked: '篮球', province: '湖北省', city: '武汉市', county: '江汉区' }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo22": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      columns: [
        { title: '日期', key: 'date', width: 200 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
        { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
        { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' },
        { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
      ],
      options: {
        maxHeight: '200px'
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo23": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date',
          width: 130
        },
        {
          title: '配送信息',
          children: [
            {
              title: '姓名',
              key: 'name'
            },
            {
              title: '地址',
              children: [
                {
                  title: '省份',
                  key: 'province'
                },
                {
                  title: '市区',
                  key: 'city'
                },
                {
                  title: '地址',
                  key: 'address'
                }
              ]
            },
          ]
        }
      ],
      data: [
        {
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-08',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-06',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        },
        {
          date: '2016-05-07',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo24": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{on:{"click":_vm.setCurrent}},[_vm._v("选中第二行")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.cancleChecked}},[_vm._v("取消选中行")]),_vm._v(" "),_c('apex-table',{ref:"apexTable",attrs:{"columns":_vm.columns,"data":_vm.data,"radio-row":""},on:{"current-change":_vm.handleCurrentChange}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ]
    }
  },
  methods: {
    handleCurrentChange (currentRow, oldCurrentRow) {
      console.log(currentRow)
      console.log(oldCurrentRow)
    },
    setCurrent() {
      this.$refs.apexTable.setCurrentRow(1)
    },
    cancleChecked() {
      this.$refs.apexTable.setCurrentRow()
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo25": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleChoose}},[_vm._v("选中第三行")]),_vm._v(" "),_c('apex-table',{ref:"apexTable",attrs:{"columns":_vm.columns,"data":_vm.data,"selection-row":_vm.selectionRow},on:{"selection-change":_vm.handleSelectionChange}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '詹姆斯',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ],
      selectionRow: {
        isRowClick: true,
        isBgc: true,
        selectable: (row, index) => {
          return row.name !== '詹姆斯'
        }
      }
    }
  },
  methods: {
    handleSelectionChange(selection) {
      console.log(selection)
    },
    handleChoose() {
      this.$refs.apexTable.toggleRowSelection(2, true)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo26": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"selection-row":_vm.selectionRow},on:{"selection-change":_vm.handleSelectionChange}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        { title: '日期', key: 'date' },
        { title: '姓名', key: 'name' },
        { title: '地址', key: 'address' }
      ],
      data: [
        { date: '2016-05-02', name: '杜兰特', address: '上海市普陀区金沙江路 1518 弄' },
        { date: '2016-05-04', name: '詹姆斯', address: '上海市普陀区金沙江路 1517 弄' },
        { date: '2016-05-01', name: '奥尼尔', address: '上海市普陀区金沙江路 1519 弄' },
        { date: '2016-05-03', name: '王小虎', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-05', name: '关云长', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-06', name: '潘神汪', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-07', name: '王五以', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-08', name: '赵六三', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-09', name: '盲僧神', address: '上海市普陀区金沙江路 1516 弄' },
        { date: '2016-05-10', name: '赵子龙', address: '上海市普陀区金沙江路 1516 弄' },
      ],
      selectionRow: {
        hidden: true
      }
    }
  },
  methods: {
    handleSelectionChange (selection) {
      console.log(selection)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo27": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.reset}},[_vm._v("重置加载状态")]),_vm._v(" "),_c('apex-table',{ref:"apexTable",attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options,"selection-row":_vm.selectionRow},on:{"selection-change":_vm.selectionChange}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      selectionRow: {
        isRowClick: true,
        isBgc: false,
        isTree: true,
        // selectable: (row, index) => {
        //   return row.id !== 555
        // }
      },
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          id: 1,
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          children: []
        },
        {
          id: 2,
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          id: 3,
          date: '2016-05-01',
          name: '我是懒加载1',
          address: '上海市普陀区金沙江路 1519 弄',
          hasChildren: true
        },
        {
          id: 4,
          date: '2016-05-03',
          name: '我是懒加载2',
          address: '上海市普陀区金沙江路 1516 弄',
          hasChildren: true
        },
        {
          id: 5,
          date: '2016-05-03',
          name: '王小虎5',
          address: '上海市普陀区金沙江路 1516 弄',
          children: [
            {
              id: 55,
              date: '2016-05-55',
              name: '王小虎55',
              address: '上海市普陀区金沙江路 1516 弄',
              children: [
                {
                  id: 555,
                  date: '2016-05-55',
                  name: '王小虎555',
                  address: '上海市普陀区金沙江路 1516 弄',
                },
                {
                  id: 556,
                  date: '2016-05-55',
                  name: '王小虎556',
                  address: '上海市普陀区金沙江路 1516 弄',
                }
              ]
            }
          ]
        }
      ],
      options: {
        rowKey: 'id',
        lazy: true,
        load: this.load
      }
    }
  },
  methods: {
    reset() {
      this.$refs.apexTable.resetAllExpandRowStatus()
    },
    load(row, treeNode, resolve) {
      if (row.id === 3) {
          setTimeout(() => {
            const res = [
              {
                id: 31,
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
              }, {
                id: 32,
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
              }
            ]
            this.$refs.apexTable.lazyLoadNodeAssociat(row, res)
            resolve(res)
        }, 1000)
      } else if (row.id === 4) {
        setTimeout(() => {
          const res = [
            {
              id: 41,
              date: '2016-05-01',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 42,
              date: '2016-05-01',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }
          ]
          this.$refs.apexTable.lazyLoadNodeAssociat(row, res)
          resolve(res)
        }, 1000)
      }
    },
    selectionChange(selection) {
      console.log(selection)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo28": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: '标签',
          key: 'tag',
          filters: [
            { text: '家', value: '家' },
            { text: '公司', value: '公司' }
          ],
          filterMethod (value, row) {
            return row.tag === value
          },
          filterPlacement: 'bottom-end'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          tag: '家'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          tag: '公司'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          tag: '家'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          tag: '公司'
        }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo29": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '数值 1',
          key: 'amount1'
        },
        {
          title: '数值 2',
          key: 'amount2'
        },
        {
          title: '数值 3',
          key: 'amount3'
        }
      ],
      data: [
        {
          id: '12987122',
          name: '王小虎',
          amount1: '234',
          amount2: '3.2',
          amount3: 10
        },
        {
          id: '12987123',
          name: '王小虎',
          amount1: '165',
          amount2: '4.43',
          amount3: 12
        },
        {
          id: '12987124',
          name: '王小虎',
          amount1: '324',
          amount2: '1.9',
          amount3: 9
        },
        {
          id: '12987125',
          name: '王小虎',
          amount1: '621',
          amount2: '2.2',
          amount3: 17
        },
        {
          id: '12987126',
          name: '王小虎',
          amount1: '539',
          amount2: '4.1',
          amount3: 15
        }
      ],
      options: {
        showSummary: true,
        summaryMethod (param) {
          const { columns, data } = param
          const sums = []
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = '总价'
              return
            }
            const values = data.map(item => Number(item[column.property]))
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                  return prev + curr
                } else {
                  return prev
                }
              }, 0)
              sums[index] += ' 元'
            } else {
              sums[index] = 'N/A'
            }
          })

          return sums
        }
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo30": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '数值 1',
          key: 'amount1'
        },
        {
          title: '数值 2',
          key: 'amount2'
        },
        {
          title: '数值 3',
          key: 'amount3'
        }
      ],
      data: [
        {
          id: '12987122',
          name: '王小虎',
          amount1: '234',
          amount2: '3.2',
          amount3: 10
        },
        {
          id: '12987123',
          name: '王小虎',
          amount1: '165',
          amount2: '4.43',
          amount3: 12
        },
        {
          id: '12987124',
          name: '王小虎',
          amount1: '324',
          amount2: '1.9',
          amount3: 9
        },
        {
          id: '12987125',
          name: '王小虎',
          amount1: '621',
          amount2: '2.2',
          amount3: 17
        },
        {
          id: '12987126',
          name: '王小虎',
          amount1: '539',
          amount2: '4.1',
          amount3: 15
        }
      ],
      options: {
        border: true,
        spanMethod ({ row, column, rowIndex, columnIndex }) {
          if (rowIndex % 2 === 0) {
            if (columnIndex === 0) {
              return [1, 2]
            } else if (columnIndex === 1) {
              return [0, 0]
            }
          }
        }
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo31": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '数值 1',
          key: 'amount1'
        },
        {
          title: '数值 2',
          key: 'amount2'
        },
        {
          title: '数值 3',
          key: 'amount3'
        }
      ],
      data: [
        {
          id: '12987122',
          name: '王小虎',
          amount1: '234',
          amount2: '3.2',
          amount3: 10
        },
        {
          id: '12987123',
          name: '王小虎',
          amount1: '165',
          amount2: '4.43',
          amount3: 12
        },
        {
          id: '12987124',
          name: '王小虎',
          amount1: '324',
          amount2: '1.9',
          amount3: 9
        },
        {
          id: '12987125',
          name: '王小虎',
          amount1: '621',
          amount2: '2.2',
          amount3: 17
        },
        {
          id: '12987126',
          name: '王小虎',
          amount1: '539',
          amount2: '4.1',
          amount3: 15
        }
      ],
      options: {
        border: true,
        spanMethod ({ row, column, rowIndex, columnIndex }) {
          if (columnIndex === 0) {
            if (rowIndex % 2 === 0) {
              return {
                rowspan: 2,
                colspan: 1
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0
              }
            }
          }
        }
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo32": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"pagination":_vm.pagination},on:{"pagination-current-change":_vm.paginationCurrentChange}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        { title: 'ID', key: 'id' },
        { title: '姓名', key: 'name' },
        { title: '数值 1', key: 'amount1' },
        { title: '数值 2', key: 'amount2' },
        { title: '数值 3', key: 'amount3' }
      ],
      data: [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10 },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12 },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9 },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17 },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  methods: {
    paginationCurrentChange (currentPage) {
      // 切换页数逻辑
      this.pagination.currentPage = currentPage
      // this.fetchData()
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo33": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.resetData}},[_vm._v("重新加载数据，重置客户端分页当前页")]),_vm._v(" "),_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"pagination":_vm.pagination,"client-pagination":""}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        { title: 'ID', key: 'id' },
        { title: '姓名', key: 'name' },
        { title: '数值 1', key: 'amount1' },
        { title: '数值 2', key: 'amount2' },
        { title: '数值 3', key: 'amount3' }
      ],
      data: [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10 },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12 },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9 },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17 },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987127', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987128', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987129', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987110', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987111', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987112', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987113', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987114', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987115', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987116', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987117', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987118', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987119', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987120', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987121', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987122', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987123', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
        layout: 'sizes, prev, pager, next, jumper, ->, total, slot',
        pageSizes: [5, 10, 30, 40, 50, 100]
      }
    }
  },
  methods: {
    resetData() {
      this.data = [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10 },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12 },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9 },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17 },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987127', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987128', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987129', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987110', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987111', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987112', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987113', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987114', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987115', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987116', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987117', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987118', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987119', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987120', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987121', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
        { id: '12987122', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15 },
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo34": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"options":{ height: 400 }},on:{"expand-change":_vm.onExpandChange},scopedSlots:_vm._u([{key:"expandSlot",fn:function(ref){
var scope = ref.scope;
return [_c('apex-table',{attrs:{"columns":_vm.columns2,"data":scope.row.tableData}})]}}])})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns2: [
        { title: '日期', key: 'date', width: 300 },
        { title: '姓名', key: 'name', width: 300 },
        { title: '地址', key: 'address1', width: 300 },
        { title: '地址', key: 'address2', width: 300 },
        { title: '地址', key: 'address3', width: 300 },
        { title: '地址', key: 'address4', width: 300 },
        { title: '地址', key: 'address5', width: 300 },
        { title: '地址', key: 'address6', width: 300 },
        { title: '地址', key: 'address7', width: 300 },
        { title: '地址', key: 'address8', width: 300 },
        { title: '地址', key: 'address9', width: 300 }
      ],
      columns: [
        {
          type: 'expand',
          slotName: 'expandSlot'
        },
        { title: 'ID', key: 'id', width: 200, fixed: 'left' },
        { title: '姓名', key: 'name', width: 300 },
        { title: '数值 1', key: 'amount1', width: 300 },
        { title: '数值 2', key: 'amount2', width: 300 },
        { title: '数值 3', key: 'amount3', width: 300 },
        { title: '数值 1', key: 'amount4', width: 300 },
        { title: '数值 2', key: 'amount5', width: 300 },
        { title: '数值 3', key: 'amount6', width: 300 },
        { title: '数值 1', key: 'amount7', width: 300 },
        { title: '数值 2', key: 'amount8', width: 300 },
        { title: '数值 3', key: 'amount9', width: 300 },
        { title: '数值 1', key: 'amount10', width: 300 },
        { title: '数值 2', key: 'amount11', width: 300 },
        { title: '数值 3', key: 'amount12', width: 300 },
      ],
      data: [
        { id: '12987122', name: '王小虎', amount1: '234', amount2: '3.2', amount3: 10,
          tableData: [
            { date: '2020-04-12', name: '詹姆斯', address: '武汉市江汉区泛海国际SOHO城 1518 弄' }, 
            { date: '2020-04-14', name: '安东尼', address: '武汉市江汉区泛海国际SOHO城 1517 弄' }, 
            { date: '2020-04-11', name: '奥尼尔', address: '武汉市江汉区泛海国际SOHO城 1519 弄' }, 
            { date: '2020-04-13', name: '杜兰特', address: '武汉市江汉区泛海国际SOHO城 1516 弄' }
          ]
        },
        { id: '12987123', name: '王小虎', amount1: '165', amount2: '4.43', amount3: 12, tableData: [] },
        { id: '12987124', name: '王小虎', amount1: '324', amount2: '1.9', amount3: 9, tableData: [] },
        { id: '12987125', name: '王小虎', amount1: '621', amount2: '2.2', amount3: 17, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
        { id: '12987126', name: '王小虎', amount1: '539', amount2: '4.1', amount3: 15, tableData: [] },
      ]
    }
  },
  methods: {
    onExpandChange(row, expandRows) {
      console.log(row, expandRows)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo35": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"row-handle":_vm.rowHandle},on:{"row-remove":_vm.handleRowRemove}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          forbidRemove: true,
          showRemoveButton: true
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          forbidRemove: false,
          showRemoveButton: true
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          forbidRemove: false,
          showRemoveButton: false
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          forbidRemove: false,
          showRemoveButton: true
        }
      ],
      rowHandle: {
        remove: {
          icon: 'el-icon-delete',
          size: 'small',
          fixed: 'right',
          confirm: true,
          show (index, row) {
            if (row.showRemoveButton) {
              return true
            }
            return false
          },
          disabled (index, row) {
            if (row.forbidRemove) {
              return true
            }
            return false
          }
        }
      }
    }
  },
  methods: {
    handleRowRemove({ index, row }, done) {
      setTimeout(() => {
        console.log(index)
        console.log(row)
        this.$message({
          message: '删除成功',
          type: 'success'
        })
        done()
      }, 300)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo36": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data,"row-handle":_vm.rowHandle},on:{"custom-emit-1":_vm.handleCustomEvent}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '地址',
          key: 'address'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }
      ],
      rowHandle: {
        custom: [
          {
            text: '自定义按钮',
            type: 'warning',
            size: 'small',
            emit: 'custom-emit-1'
          }
        ]
      }
    }
  },
  methods: {
    handleCustomEvent({index, row}) {
      console.log(index)
      console.log(row)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo37": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data},on:{"cell-data-change":_vm.handleCellDataChange}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        { title: '日期', key: 'date', align: 'center',
          component: {
            name: 'el-date-picker',
            size: 'small'
          }
        },
        { title: '姓名', key: 'name', align: 'center',
          component: {
            name: 'el-select',
            options: [
              {
                value: '王小虎',
                label: '王小虎'
              },
              {
                value: '王中虎',
                label: '王中虎'
              },
              {
                value: '王老虎',
                label: '王老虎'
              }
            ],
            size: 'small'
          }
        },
        { title: '地址', key: 'address', align: 'center',
          component: {
            name: 'el-input',
            size: 'small',
            float: 4,
            keyup: ({ row, rowIndex, key, value }) => {
              this.keyupTest(row)
            }
          }
        },
        { title: '是否发送?', key: 'isSend', align: 'center', width: 100,
          component: {
            name: 'el-checkbox',
            trueLabel: 1,
            falseLabel: 0
          }
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          isSend: 0
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          isSend: 1
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          isSend: 0
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          isSend: 0
        }
      ]
    }
  },
  methods: {
    handleCellDataChange({ rowIndex, key, value, row }) {
      console.log(rowIndex)
      console.log(key)
      console.log(value)
      console.log(row)
    },
    keyupTest(row) {
      console.log(row)
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo38": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '正整数',
          key: 'num1',
          component: {
            name: 'el-input',
            placeholder: '请输入正整数',
            size: 'small',
            onlyNumber: true
          }
        },
        {
          title: '大于等于0小于等于200',
          key: 'num2',
          component: {
            name: 'el-input',
            placeholder: '请输入大于等于0小于等于200的数',
            size: 'small',
            onlyNumber: {
              max: 200,
              min: 0
            }
          }
        },
        {
          title: '保留三位小数',
          key: 'num3',
          component: {
            name: 'el-input',
            placeholder: '请输入正数保留三位小数',
            size: 'small',
            onlyNumber: {
              toFixed: 3
            }
          }
        },
        {
          title: '数字随意输',
          key: 'num4',
          component: {
            name: 'el-input',
            placeholder: '不限制输入数字，例如 000013',
            size: 'small',
            onlyNumber: {
              type: 'zeroBefore'
            }
          }
        }
      ],
      data: [
        { date: '', name: '', address: '' },
        { date: '', name: '', address: '' },
        { date: '', name: '', address: '' },
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo39": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date',
          width: '180'
        },
        {
          title: '姓名',
          key: 'name',
          width: '180'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: 'ApexLink组件，点击可跳转',
          key: 'check',
          component: {
            name: 'apex-link',
            props: {
              value: '我是通过props传过来的数据！',
              to: '/'
            }
          }
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          check: true
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          check: false
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          check: true
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          check: true
        }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo40": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-table',{attrs:{"columns":_vm.columns,"data":_vm.data},scopedSlots:_vm._u([{key:"linkSlot",fn:function(ref){
var scope = ref.scope;
return [_c('apex-link',{attrs:{"type":"success","to":"/","params":{ name: 'wuhao', age: '18' }}},[_vm._v(_vm._s(scope.row.check))])]}}])})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data () {
    return {
      columns: [
        {
          title: '日期',
          key: 'date',
          width: '180'
        },
        {
          title: '姓名',
          key: 'name',
          width: '180'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: 'ApexLink组件，点击可跳转',
          key: 'check',
          slotName: 'linkSlot'
        }
      ],
      data: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
          check: '测试111'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄',
          check: '测试222'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          check: '测试333'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄',
          check: '测试444'
        }
      ]
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  